(function () {
  'use strict';

  var LIVE_PRODUCT_CACHE = {};
  var MAX_FAMILIES = 5;
  var LARGE_PHONE_CLASS_MIN_LENGTH = 146.1;
  var PHONE_SIZE_CLASS_BONUS = 420;
  var THICK_PHONE_THRESHOLD = 14;
  var QUICK_GRIP_PRO_SUITABILITY_BONUS = 140;
  var PUBLISHED_COMPATIBILITY_BONUS = 900;
  var PUBLISHED_BARE_DEVICE_TOLERANCE_MM = 1;
  var TAB_CRADLE_WIDTH_FIT_BONUS = 180;
  var TAB_CRADLE_IDEAL_WIDTH_CLEARANCE_MM = 4;
  var TAB_CRADLE_MAX_USEFUL_WIDTH_CLEARANCE_MM = 32;
  var MAX_VISIBLE_TABLET_ALTERNATIVES = 3;
  var AVAILABILITY_TIMEOUT_MS = 4500;
  var PHONE_CASE_ALLOWANCES = {
    slim: { length: 7, width: 8, thickness: 8 },
    rugged: { length: 12.5, width: 13.5, thickness: 9 }
  };
  var FINDER_VERSION = '2.8';
  var FINDER_STORAGE_KEY = 'mm-holder-finder-search-v2.8';
  var FINDER_ATTRIBUTION_KEY = 'mm-holder-finder-product-attribution-v1';
  var CONTACT_EMAIL = 'info@modestmounts.com.au';

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-mm-holder-finder]');

    if (!root) {
      return;
    }

    var form = root.querySelector('#mm-finder-form');
    var typeSelect = root.querySelector('#mm-finder-device-type');
    var typeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-mm-device-type]'));
    var brandSelect = root.querySelector('#mm-finder-brand');
    var modelSelect = root.querySelector('#mm-finder-model');
    var modelPicker = root.querySelector('[data-mm-model-picker]');
    var modelSearchInput = root.querySelector('#mm-finder-model-search');
    var modelDataList = root.querySelector('#mm-finder-model-list');
    var modelSearchHelp = root.querySelector('#mm-finder-model-help');
    var modelSearchError = root.querySelector('#mm-finder-model-error');
    var modelClearButton = root.querySelector('#mm-finder-model-clear');
    var manualMeasurementsButton = root.querySelector('#mm-finder-use-measurements');
    var manualModeNote = root.querySelector('#mm-finder-manual-mode-note');
    var caseWrap = root.querySelector('#mm-finder-case-wrap');
    var caseError = root.querySelector('#mm-finder-case-error');
    var caseChoiceNote = root.querySelector('#mm-finder-case-choice-note');
    var caseMethodWrap = root.querySelector('#mm-finder-case-method');
    var caseMethodError = root.querySelector('#mm-finder-case-method-error');
    var measurementWrap = root.querySelector('#mm-finder-measurements');
    var measurementNote = root.querySelector('#mm-finder-measurement-note');
    var measurementError = root.querySelector('#mm-finder-measurement-error');
    var measurementWarning = root.querySelector('#mm-finder-measurement-warning');
    var measurementWarningText = root.querySelector('#mm-finder-measurement-warning-text');
    var convertMeasurementsButton = root.querySelector('#mm-finder-convert-measurements');
    var lengthInput = root.querySelector('#mm-finder-length');
    var widthInput = root.querySelector('#mm-finder-width');
    var thicknessInput = root.querySelector('#mm-finder-thickness');
    var submitButton = root.querySelector('#mm-finder-submit');
    var resetButton = root.querySelector('#mm-finder-reset');
    var editButton = root.querySelector('#mm-finder-edit');
    var panelSummary = root.querySelector('#mm-finder-panel-summary');
    var summaryDevice = root.querySelector('#mm-finder-summary-device');
    var summaryMeta = root.querySelector('#mm-finder-summary-meta');
    var stepElements = Array.prototype.slice.call(root.querySelectorAll('[data-mm-step]'));
    var status = root.querySelector('#mm-finder-status');
    var results = root.querySelector('#mm-finder-results');
    var devicesUrl = root.getAttribute('data-devices-url');
    var productsUrl = root.getAttribute('data-products-url');
    var modelPickerDevices = [];
    var visibleModelDevices = [];
    var activeModelOptionIndex = -1;
    var modelBlurTimer = null;

    var state = {
      devices: [],
      products: [],
      families: [],
      evidenceRules: {},
      selectedDevice: null,
      dimensions: null,
      caseChoice: '',
      caseMethod: '',
      familyMatches: [],
      showVibration: false,
      vibrationRevealPending: false,
      manualMeasurements: false,
      hasResults: false,
      searchRunId: 0,
      selectedKitFamilyKey: '',
      selectedKitCategory: '',
      restoringSearch: false,
      availabilityTimeoutId: null,
      availabilityTimedOut: false
    };

    setLoadingState();

    Promise.all([
      fetchJson(devicesUrl),
      fetchJson(productsUrl)
    ]).then(function (payloads) {
      state.devices = Array.isArray(payloads[0]) ? payloads[0] : [];
      state.products = payloads[1] && Array.isArray(payloads[1].products) ? payloads[1].products : [];
      state.evidenceRules = payloads[1] && payloads[1].evidenceRules ? payloads[1].evidenceRules : {};
      state.families = buildFamilies(state.products);

      populateTypeOptions();
      manualMeasurementsButton.disabled = true;
      submitButton.disabled = true;
      updateStepStates();
      var restoredSearch = restoreSearchState();

      if (restoredSearch && restoredSearch.shouldRun) {
        window.setTimeout(runFinder, 0);
      } else {
        renderEmpty();
      }
    }).catch(function (error) {
      console.error('Holder Finder data failed to load', error);
      setResultsMode('error');
      results.innerHTML = [
        '<div class="mm-holder-finder__warning">',
        '<strong>We could not load the holder finder data.</strong><br>',
        'Please refresh the page and try again.',
        '</div>'
      ].join('');
    });

    typeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var selectedType = button.getAttribute('data-mm-device-type');

        if (!selectedType || button.disabled) {
          return;
        }

        typeSelect.value = selectedType;
        typeSelect.dispatchEvent(new Event('change', { bubbles: true }));

        if (!brandSelect.disabled) {
          brandSelect.focus();
        }
      });
    });

    typeSelect.addEventListener('change', function () {
      resetSelect(brandSelect, 'Select brand');
      resetSelect(modelSelect, 'Select model');
      resetModelSearch();
      state.manualMeasurements = false;
      state.hasResults = false;
      brandSelect.disabled = !typeSelect.value;
      modelSelect.disabled = true;
      modelSearchInput.disabled = true;
      manualMeasurementsButton.disabled = !typeSelect.value;
      clearCaseChoice();
      updateManualModeControls();
      caseWrap.hidden = true;
      measurementWrap.hidden = true;
      clearMeasurements();
      clearValidation();
      syncTypeButtons();
      syncMeasurementPlaceholders();
      syncFinderControls();
      renderEmpty();

      if (typeSelect.value) {
        populateBrandOptions(typeSelect.value);
      }

      updateStepStates();
    });

    brandSelect.addEventListener('change', function () {
      resetSelect(modelSelect, 'Select model');
      resetModelSearch();
      clearCaseChoice();
      clearValidation();

      if (brandSelect.value) {
        populateModelOptions(typeSelect.value, brandSelect.value);
      }

      if (state.manualMeasurements) {
        modelSelect.disabled = true;
        modelSearchInput.disabled = true;
        caseWrap.hidden = false;
        updateMeasurementVisibility();
      } else {
        modelSelect.disabled = !brandSelect.value;
        modelSearchInput.disabled = !brandSelect.value;
        caseWrap.hidden = true;
        measurementWrap.hidden = true;
      }

      syncFinderControls();
      syncModelClearButton();
      updateStepStates();
      renderEmpty();
    });

    modelSelect.addEventListener('change', function () {
      var hasModel = Boolean(modelSelect.value);
      syncModelSearchFromSelection();
      clearCaseChoice();
      clearValidation();

      if (hasModel && state.manualMeasurements) {
        state.manualMeasurements = false;
        updateManualModeControls();
      }

      caseWrap.hidden = !hasModel;
      updateMeasurementVisibility();
      syncFinderControls();
      syncModelClearButton();
      updateStepStates();
      renderEmpty();
    });

    modelSearchInput.addEventListener('focus', function () {
      openModelList();
    });

    modelSearchInput.addEventListener('click', function () {
      openModelList();
    });

    modelSearchInput.addEventListener('input', function () {
      var selectedDevice = getSelectedModelDevice();
      var stillMatchesSelection = selectedDevice && normalizeSearchText(modelSearchInput.value) === normalizeSearchText(selectedDevice.model);

      if (modelSelect.value && !stillMatchesSelection) {
        modelSelect.value = '';
        modelSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      renderModelList(modelSearchInput.value);
      openModelList(false);

      if (modelSearchError) {
        modelSearchError.hidden = true;
      }
      syncModelClearButton();
    });

    if (modelClearButton) {
      modelClearButton.addEventListener('click', function (event) {
        if (modelSearchInput.disabled) {
          return;
        }
        event.stopPropagation();
        modelSearchInput.value = '';
        modelSelect.value = '';
        modelSelect.dispatchEvent(new Event('change', { bubbles: true }));
        syncModelClearButton();
        modelSearchInput.focus();
        openModelList();
      });
    }

    modelSearchInput.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        openModelList(false);
        moveActiveModelOption(1);
        return;
      }

      if (event.key === 'ArrowUp') {
        event.preventDefault();
        openModelList(false);
        moveActiveModelOption(-1);
        return;
      }

      if (event.key === 'Enter' && !modelDataList.hidden) {
        var enterChoice = activeModelOptionIndex > -1
          ? visibleModelDevices[activeModelOptionIndex]
          : visibleModelDevices.length === 1 ? visibleModelDevices[0] : null;
        if (enterChoice) {
          event.preventDefault();
          commitModelChoice(enterChoice);
          return;
        }
      }

      if (event.key === 'Escape') {
        closeModelList();
      }
    });

    modelSearchInput.addEventListener('blur', function () {
      window.clearTimeout(modelBlurTimer);
      modelBlurTimer = window.setTimeout(function () {
        closeModelList();
        if (modelSearchInput.value.trim() && !modelSelect.value && modelSearchError) {
          modelSearchError.hidden = false;
        }
      }, 140);
    });

    modelDataList.addEventListener('mousedown', function (event) {
      if (event.target.closest('[data-mm-model-option]')) {
        event.preventDefault();
      }
    });

    modelDataList.addEventListener('click', function (event) {
      var option = event.target.closest('[data-mm-model-option]');
      if (!option) {
        return;
      }
      var device = modelPickerDevices.find(function (item) {
        return item.slug === option.getAttribute('data-mm-model-option');
      });
      commitModelChoice(device);
    });

    document.addEventListener('click', function (event) {
      if (modelPicker && !modelPicker.contains(event.target)) {
        closeModelList();
      }
    });

    manualMeasurementsButton.addEventListener('click', function () {
      state.manualMeasurements = !state.manualMeasurements;
      clearCaseChoice();
      clearValidation();

      if (state.manualMeasurements) {
        modelSelect.value = '';
        modelSelect.disabled = true;
        modelSearchInput.value = '';
        modelSearchInput.disabled = true;
        caseWrap.hidden = false;
      } else {
        modelSelect.disabled = !brandSelect.value;
        modelSearchInput.disabled = !brandSelect.value;
        caseWrap.hidden = !modelSelect.value;
      }

      updateManualModeControls();
      updateMeasurementVisibility();
      syncModelClearButton();
      syncFinderControls();
      updateStepStates();
      renderEmpty();

      if (state.manualMeasurements) {
        trackFinderEvent('manual_measurement_mode_selected', {
          device_type: typeSelect.value || ''
        });
      }
    });

    root.querySelectorAll('input[name="mm-finder-case"]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (caseError) {
          caseError.hidden = true;
        }
        if (input.value !== 'case') {
          clearCaseMethodChoice();
          clearMeasurements();
        }
        updateMeasurementVisibility();
        validateMeasurements(false);
        syncFinderControls();
        updateStepStates();
        renderEmpty();
      });
    });

    root.querySelectorAll('input[name="mm-finder-case-method"]').forEach(function (input) {
      input.addEventListener('change', function () {
        state.caseMethod = input.value;
        if (caseMethodError) {
          caseMethodError.hidden = true;
        }
        if (input.value !== 'measure') {
          clearMeasurements();
        }
        updateMeasurementVisibility();
        validateMeasurements(false);
        syncFinderControls();
        updateStepStates();
        renderEmpty();
        trackFinderEvent('phone_case_method_selected', {
          device_slug: modelSelect.value || '',
          case_method: input.value
        });
      });
    });

    [lengthInput, widthInput, thicknessInput].forEach(function (input) {
      input.addEventListener('input', function () {
        validateMeasurements(false);
        updateMeasurementPlausibility();
        syncFinderControls();
        updateStepStates();

        if (state.hasResults) {
          renderEmpty();
        }
      });
    });

    if (convertMeasurementsButton) {
      convertMeasurementsButton.addEventListener('click', function () {
        [lengthInput, widthInput, thicknessInput].forEach(function (input) {
          input.value = String(Number((Number(input.value) * 25.4).toPrecision(15)));
        });
        updateMeasurementPlausibility();
        syncFinderControls();
        updateStepStates();
        trackFinderEvent('measurement_units_converted', {
          device_type: typeSelect.value || ''
        });
        lengthInput.focus();
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      runFinder();
    });

    resetButton.addEventListener('click', function () {
      cancelActiveSearch();
      typeSelect.value = '';
      resetSelect(brandSelect, 'Select brand');
      resetSelect(modelSelect, 'Select model');
      resetModelSearch();
      brandSelect.disabled = true;
      modelSelect.disabled = true;
      modelSearchInput.disabled = true;
      caseWrap.hidden = true;
      measurementWrap.hidden = true;
      clearMeasurements();
      clearCaseChoice();
      clearValidation();
      state.selectedDevice = null;
      state.dimensions = null;
      state.familyMatches = [];
      state.caseChoice = '';
      state.caseMethod = '';
      state.showVibration = false;
      state.vibrationRevealPending = false;
      state.manualMeasurements = false;
      state.hasResults = false;
      state.selectedKitFamilyKey = '';
      state.selectedKitCategory = '';
      state.availabilityTimedOut = false;
      manualMeasurementsButton.disabled = true;
      clearSavedSearchState();
      updateManualModeControls();
      syncTypeButtons();
      syncFinderControls();
      updateStepStates();
      renderEmpty();

      if (typeButtons[0]) {
        typeButtons[0].focus();
      }
    });

    if (editButton) {
      editButton.addEventListener('click', function () {
        openFinderEditor();
      });
    }

    results.addEventListener('click', function (event) {
      var measurementButton = event.target.closest('[data-mm-check-measurements]');
      if (measurementButton) {
        openFinderEditor(measurementWrap.hidden ? getEditFocusTarget() : lengthInput);
        trackFinderEvent('no_match_measurements_edit', getAnalyticsSearchContext());
        return;
      }

      var vibrationButton = event.target.closest('[data-mm-show-vibration]');
      if (vibrationButton) {
        state.showVibration = true;
        state.vibrationRevealPending = true;
        trackFinderEvent('vibe_safe_selected', getAnalyticsSearchContext());
        renderFamilyResults(state.familyMatches, true, false);
        revealVibrationOptions();
        return;
      }

      var kitCategoryButton = event.target.closest('[data-mm-kit-category]');
      if (kitCategoryButton) {
        selectKitCategory(kitCategoryButton);
        return;
      }

      var shareButton = event.target.closest('[data-mm-copy-result-link]');
      if (shareButton) {
        copyResultLink(shareButton);
        return;
      }

      var kitsButton = event.target.closest('[data-mm-select-holder-for-kits]');
      if (kitsButton) {
        var familyKey = kitsButton.getAttribute('data-mm-select-holder-for-kits');
        selectFamilyForKitBuilder(familyKey, kitsButton);
        return;
      }

      var productLink = event.target.closest('[data-mm-product-link]');
      if (productLink) {
        var productKind = productLink.getAttribute('data-mm-product-kind');
        var clickEventName = productKind === 'kit' ? 'complete_kit_click' : productKind === 'support' ? 'support_email_opened' : 'product_click';
        if (productKind !== 'support') {
          saveFinderProductAttribution(productLink, productKind);
        }
        trackFinderEvent(clickEventName, {
          device_slug: state.selectedDevice ? state.selectedDevice.slug : '',
          family_key: productLink.getAttribute('data-mm-family-key') || '',
          sku: productLink.getAttribute('data-mm-sku') || ''
        });
      }

      var detailsSummary = event.target.closest('summary');
      if (detailsSummary && detailsSummary.parentElement &&
          (detailsSummary.parentElement.classList.contains('mm-holder-finder__related-details') ||
           detailsSummary.parentElement.classList.contains('mm-holder-finder__more-options'))) {
        window.setTimeout(function () {
          if (detailsSummary.parentElement.open) {
            trackFinderEvent('alternatives_expanded', getAnalyticsSearchContext());
          }
        }, 0);
      }
    });

    function setLoadingState() {
      typeSelect.disabled = true;
      brandSelect.disabled = true;
      modelSelect.disabled = true;
      modelSearchInput.disabled = true;
      submitButton.disabled = true;
      typeButtons.forEach(function (button) {
        button.disabled = true;
      });
      setResultsMode('loading');
      results.innerHTML = [
        '<div class="mm-holder-finder__empty">',
        '<span class="mm-holder-finder__loader" aria-hidden="true"></span>',
        '<h2>Loading holder finder...</h2>',
        '<p>Preparing the latest device and holder compatibility data.</p>',
        '</div>'
      ].join('');
    }

    function populateTypeOptions() {
      resetSelect(typeSelect, 'Select phone or tablet');
      unique(state.devices.map(function (device) {
        return device.type;
      })).sort().forEach(function (type) {
        addOption(typeSelect, type, type);
      });
      typeSelect.disabled = false;
      syncTypeButtons();
    }

    function populateBrandOptions(type) {
      unique(state.devices.filter(function (device) {
        return device.type === type;
      }).map(function (device) {
        return device.brand;
      })).sort().forEach(function (brand) {
        addOption(brandSelect, brand, brand);
      });
    }

    function populateModelOptions(type, brand) {
      modelPickerDevices = state.devices.filter(function (device) {
        return device.type === type && device.brand === brand;
      }).sort(function (a, b) {
        return a.model.localeCompare(b.model, undefined, { numeric: true, sensitivity: 'base' });
      });

      modelPickerDevices.forEach(function (device) {
        addOption(modelSelect, device.slug, device.model);
      });
      renderModelList('');

      if (modelSearchHelp) {
        modelSearchHelp.hidden = !modelPickerDevices.length;
      }
    }

    function updateMeasurementVisibility() {
      var caseChoice = getCaseChoice();
      var choosePhoneCaseMethod = shouldChoosePhoneCaseMethod();
      caseMethodWrap.hidden = !choosePhoneCaseMethod;
      measurementWrap.hidden = !measurementsAreRequired();

      if (!measurementWrap.hidden && measurementNote) {
        measurementNote.textContent = caseChoice === 'case'
          ? 'Measure the device while it is inside the case you plan to use.'
          : 'Measure the device without a case.';
      }
    }

    function updateManualModeControls() {
      manualMeasurementsButton.textContent = state.manualMeasurements
        ? 'Use model selection instead'
        : 'Can’t find your exact device? Use measurements instead';

      if (manualModeNote) {
        manualModeNote.hidden = !state.manualMeasurements;
      }

      if (modelSearchHelp) {
        modelSearchHelp.hidden = state.manualMeasurements || !brandSelect.value;
      }
    }

    function syncTypeButtons() {
      typeButtons.forEach(function (button) {
        var value = button.getAttribute('data-mm-device-type');
        var isAvailable = Array.prototype.some.call(typeSelect.options, function (option) {
          return option.value === value;
        });
        button.disabled = typeSelect.disabled || !isAvailable;
        button.setAttribute('aria-pressed', typeSelect.value === value ? 'true' : 'false');
      });

      if (caseChoiceNote) {
        caseChoiceNote.textContent = typeSelect.value === 'Tablet'
          ? 'Measurements required'
          : 'Estimate or measure';
      }
    }

    function syncFinderControls() {
      var device = getSelectedDevice();
      var caseChoice = getCaseChoice();
      var needsMeasurements = measurementsAreRequired();
      var caseMethodComplete = !shouldChoosePhoneCaseMethod() || Boolean(getCaseMethod());
      var canSubmit = Boolean(device && caseChoice && caseMethodComplete);
      var readyToFind = Boolean(canSubmit && (!needsMeasurements || measurementsAreComplete()));

      submitButton.disabled = !canSubmit;
      resetButton.hidden = !typeSelect.value;
      root.classList.toggle('is-ready-to-find', readyToFind);
    }

    function updateStepStates() {
      var hasType = Boolean(typeSelect.value);
      var hasDevice = Boolean(getSelectedDevice());
      var caseChoice = getCaseChoice();
      var needsMeasurements = measurementsAreRequired();
      var caseMethodComplete = !shouldChoosePhoneCaseMethod() || Boolean(getCaseMethod());
      var setupComplete = Boolean(hasDevice && caseChoice && caseMethodComplete && (!needsMeasurements || measurementsAreComplete()));

      setStepState(1, hasType ? 'complete' : 'active');
      setStepState(2, !hasType ? 'unavailable' : hasDevice ? 'complete' : 'active');
      setStepState(3, !hasDevice ? 'unavailable' : setupComplete ? 'complete' : 'active');
    }

    function setStepState(number, nextState) {
      var step = stepElements.find(function (item) {
        return item.getAttribute('data-mm-step') === String(number);
      });

      if (!step) {
        return;
      }

      step.classList.remove('is-active', 'is-complete', 'is-unavailable');
      step.classList.add('is-' + nextState);
      step.setAttribute('aria-disabled', nextState === 'unavailable' ? 'true' : 'false');

      if (nextState === 'active') {
        step.setAttribute('aria-current', 'step');
      } else {
        step.removeAttribute('aria-current');
      }
    }

    function runFinder() {
      var device = getSelectedDevice();

      if (!device) {
        focusCurrentStep();
        return;
      }

      var caseChoice = getCaseChoice();

      if (!caseChoice) {
        if (caseError) {
          caseError.hidden = false;
        }
        var firstCaseInput = root.querySelector('input[name="mm-finder-case"]');
        if (firstCaseInput) {
          firstCaseInput.focus();
        }
        return;
      }

      var caseMethod = getCaseMethod();

      if (shouldChoosePhoneCaseMethod() && !caseMethod) {
        if (caseMethodError) {
          caseMethodError.hidden = false;
        }
        var firstCaseMethodInput = root.querySelector('input[name="mm-finder-case-method"]');
        if (firstCaseMethodInput) {
          firstCaseMethodInput.focus();
        }
        return;
      }

      if (!validateMeasurements(true)) {
        var firstInvalid = root.querySelector('.mm-holder-finder__input[aria-invalid="true"]');
        if (firstInvalid) {
          firstInvalid.focus();
        }
        return;
      }

      if (!validateMeasurementPlausibility(true)) {
        lengthInput.focus();
        return;
      }

      var dimensions = getMatchingDimensions(device, caseChoice);

      if (!dimensions) {
        validateMeasurements(true);
        return;
      }

      state.selectedDevice = device;
      state.dimensions = dimensions;
      state.caseChoice = caseChoice;
      state.caseMethod = caseMethod;
      state.showVibration = false;
      state.vibrationRevealPending = false;
      state.hasResults = true;
      state.selectedKitFamilyKey = '';
      state.selectedKitCategory = '';
      state.availabilityTimedOut = false;
      if (state.availabilityTimeoutId) {
        window.clearTimeout(state.availabilityTimeoutId);
        state.availabilityTimeoutId = null;
      }
      var runId = ++state.searchRunId;
      updateQuerySummary(device, dimensions, caseChoice);
      saveSearchState(true);
      trackFinderEvent('holder_search', getAnalyticsSearchContext());
      saveFinderCartAttribution();
      root.classList.add('is-results-view');
      panelSummary.hidden = false;

      var familyMatches = scoreFamilies(device, dimensions, caseChoice);
      state.familyMatches = familyMatches;

      if (!familyMatches.length) {
        trackFinderEvent('no_match', getAnalyticsSearchContext());
        renderNoMatches(device);
        return;
      }

      setResultsMode('loading');
      results.innerHTML = [
        '<div class="mm-holder-finder__empty">',
        '<span class="mm-holder-finder__loader" aria-hidden="true"></span>',
        '<h2>Checking current availability...</h2>',
        '<p>Loading current price and stock information for the best matches.</p>',
        '</div>'
      ].join('');

      var availabilitySettled = false;
      state.availabilityTimeoutId = window.setTimeout(function () {
        if (availabilitySettled || runId !== state.searchRunId) {
          return;
        }
        availabilitySettled = true;
        state.availabilityTimeoutId = null;
        state.availabilityTimedOut = true;
        renderFamilyResults(familyMatches, false, true);
      }, AVAILABILITY_TIMEOUT_MS);

      prepareAvailabilityOrder(familyMatches).then(function (orderedMatches) {
        if (availabilitySettled || runId !== state.searchRunId) {
          return;
        }
        availabilitySettled = true;
        window.clearTimeout(state.availabilityTimeoutId);
        state.availabilityTimeoutId = null;
        state.familyMatches = orderedMatches;
        renderFamilyResults(orderedMatches, false, true);
      }).catch(function () {
        if (availabilitySettled || runId !== state.searchRunId) {
          return;
        }
        availabilitySettled = true;
        window.clearTimeout(state.availabilityTimeoutId);
        state.availabilityTimeoutId = null;
        state.availabilityTimedOut = true;
        renderFamilyResults(familyMatches, false, true);
      });
    }

    function scoreFamilies(device, dimensions, caseChoice) {
      var scored = state.families.map(function (family) {
        var candidates = family.products.filter(function (product) {
          return product.showAsMainResult === 'Yes' || product.showAsMainResult === 'Conditional' || product.fallbackOnly;
        }).filter(function (product) {
          return !isCompleteKit(product) && !isVibrationOption(product);
        });

        var scoredProducts = candidates.map(function (product) {
          return scoreProduct(product, device, dimensions, caseChoice);
        }).filter(function (match) {
          return match.score > 0;
        }).sort(compareMatches);

        if (!scoredProducts.length) {
          return null;
        }

        return {
          family: family,
          match: scoredProducts[0],
          score: scoredProducts[0].score,
          tier: scoredProducts[0].tier,
          reasons: scoredProducts[0].reasons,
          warnings: scoredProducts[0].warnings || [],
          ruleFallback: Boolean(scoredProducts[0].ruleFallback),
          evidenceConfidence: scoredProducts[0].evidenceConfidence || null,
          publishedCompatibility: Boolean(scoredProducts[0].publishedCompatibility),
          confirmedFit: Boolean(scoredProducts[0].confirmedFit),
          exactDeviceMatch: Boolean(scoredProducts[0].exactDeviceMatch),
          preferredDeviceMatch: Boolean(scoredProducts[0].preferredDeviceMatch),
          dimensionProfile: scoredProducts[0].dimensionProfile || scoredProducts[0].product,
          relatedProducts: getRelatedProducts(family, scoredProducts[0].product, false)
        };
      }).filter(Boolean).sort(compareFamilyMatches);

      var nonFallback = scored.filter(function (item) {
        return !item.match.product.fallbackOnly && !item.match.ruleFallback;
      });

      if (nonFallback.length) {
        scored = nonFallback;
      }

      return scored.slice(0, device.type === 'Tablet' ? 8 : MAX_FAMILIES);
    }

    function scoreProduct(product, device, dimensions, caseChoice) {
      var bareDeviceFitException = findBareDeviceFitException(product, device, dimensions, caseChoice);
      if (product.fitConfirmationRequired || findBareDeviceFitConfirmation(product, device, dimensions, caseChoice) || (!strictDimensionsFit(product, dimensions) && !bareDeviceFitException)) {
        return noMatch(product);
      }

      if (product.deviceTypes.indexOf(device.type) === -1) {
        return noMatch(product);
      }

      if (product.excludeDeviceSlugs.indexOf(device.slug) > -1) {
        return noMatch(product);
      }

      if (caseChoice !== 'no-case' && product.excludeWhenCaseUsed) {
        return noMatch(product);
      }

      if (matchesConfirmedNonFitAnchor(product, device, dimensions, caseChoice)) {
        return noMatch(product);
      }

      var activeRules = getApplicableDeviceFamilyRules(product, device, caseChoice);
      if (activeRules.some(function (rule) { return rule.action === 'exclude'; })) {
        return noMatch(product);
      }

      if (matchesPublishedNonFit(product, device, caseChoice)) {
        return noMatch(product);
      }

      var compatibleDevices = product.compatibleDevices || [];
      var exactDeviceMatch = compatibleDevices.indexOf(device.slug) > -1;
      var publishedCompatibility = findPublishedCompatibility(product, device, caseChoice);

      if (product.showAsMainResult === 'Conditional' && compatibleDevices.length && !exactDeviceMatch && !publishedCompatibility) {
        return noMatch(product);
      }
      var preferredDeviceMatch = (product.preferredDeviceSlugs || []).indexOf(device.slug) > -1;
      var hasDimensionRules = holderHasDimensionRules(product);
      var dimensionProfile = hasDimensionRules ? findBestDimensionProfile(product, dimensions, 0) : null;
      var dimensionMatch = Boolean(dimensionProfile);
      var publishedDimensionProfile = Boolean(publishedCompatibility) && hasDimensionRules && !dimensionProfile && caseChoice === 'no-case'
        ? findBestDimensionProfile(
            product,
            dimensions,
            publishedCompatibility.allowDimensionOverride ? Number(publishedCompatibility.dimensionOverrideToleranceMm || 1000) : PUBLISHED_BARE_DEVICE_TOLERANCE_MM
          )
        : null;
      var publishedDimensionMatch = Boolean(publishedCompatibility) && hasDimensionRules && (
        dimensionMatch || (
          caseChoice === 'no-case' &&
          (
            publishedCompatibility.allowDimensionOverride ||
            Boolean(publishedDimensionProfile)
          )
        )
      );
      var effectiveDimensionMatch = dimensionMatch || publishedDimensionMatch || Boolean(bareDeviceFitException);
      var effectiveDimensionProfile = dimensionProfile || publishedDimensionProfile || product;
      var reasons = [];
      var score = 0;
      var tier = 99;

      if (exactDeviceMatch && caseChoice === 'no-case') {
        tier = 1;
        score = 10000;
        reasons.push('Exact fit for your device');
      } else if (preferredDeviceMatch && caseChoice === 'no-case' && (!hasDimensionRules || effectiveDimensionMatch)) {
        tier = 2;
        score = 8500;
        reasons.push('Preferred match for your device');
      } else if (exactDeviceMatch && caseChoice !== 'no-case' && effectiveDimensionMatch && !product.excludeWhenCaseUsed) {
        tier = 2;
        score = 8200;
        reasons.push('Device match that also fits your measurements');
      } else if (effectiveDimensionMatch) {
        tier = product.fallbackOnly ? 6 : 3;
        score = 6000 + snugnessScore(effectiveDimensionProfile, dimensions);
        reasons.push(bareDeviceFitException
          ? 'Manufacturer-listed exception for this bare device'
          : effectiveDimensionProfile.configurationLabel
            ? 'Fits using the included ' + effectiveDimensionProfile.configurationLabel
            : 'Fits your selected dimensions');

        if (preferredDeviceMatch) {
          score += caseChoice === 'no-case' ? 700 : 180;
          reasons.push('Preferred option for this device');
        }
      } else {
        return noMatch(product);
      }

      if (publishedCompatibility) {
        score += Number(publishedCompatibility.scoreBonus || PUBLISHED_COMPATIBILITY_BONUS);
        reasons.push(publishedCompatibility.reason || 'Included in the published compatibility list for this device and setup');
      }

      var confirmedFitAnchor = findConfirmedFitAnchor(product, device, dimensions, caseChoice);
      if (confirmedFitAnchor) {
        score += Number(confirmedFitAnchor.scoreBonus || 250);
        reasons.push(confirmedFitAnchor.reason || 'Confirmed real-world fit for this setup');
      }

      if (product.variantRole === 'Exact-fit cradle') {
        score += 800;
      }

      if (product.defaultFamilyVariant === 'Yes') {
        score += 80;
      }

      score += Math.max(0, 120 - Number(product.priority || 100));
      score += getPhoneSizeClassAdjustment(product, dimensions);
      score += getQuickGripProSuitabilityAdjustment(product, dimensions);
      score += getTabCradleWidthFitAdjustment(effectiveDimensionProfile, dimensions);

      if (product.fallbackOnlyWithCase && caseChoice === 'no-case') {
        score -= 1200;
      }

      var warnings = getFitWarnings(product, device, caseChoice, activeRules, effectiveDimensionProfile);
      if (bareDeviceFitException) {
        warnings.push(bareDeviceFitException.warning);
      }
      var ruleFallback = false;
      var evidenceConfidence = null;

      activeRules.forEach(function (rule) {
        score += Number(rule.scoreDelta || 0);

        if (rule.reason) {
          reasons.push(rule.reason);
        }

        if (rule.action === 'fallback') {
          ruleFallback = true;
          tier = Math.max(tier, 6);
        }

        evidenceConfidence = strongerConfidence(evidenceConfidence, rule.confidence);
      });

      var peerAdjustment = getPeerFamilyAdjustment(product, device, caseChoice, activeRules);
      if (peerAdjustment.scoreDelta > 0) {
        score += peerAdjustment.scoreDelta;
        evidenceConfidence = strongerConfidence(evidenceConfidence, peerAdjustment.confidence);
      }

      return {
        product: product,
        score: score,
        tier: tier,
        reasons: unique(reasons),
        warnings: unique(warnings),
        ruleFallback: ruleFallback,
        evidenceConfidence: evidenceConfidence,
        publishedCompatibility: Boolean(publishedCompatibility),
        confirmedFit: Boolean(confirmedFitAnchor),
        exactDeviceMatch: exactDeviceMatch,
        preferredDeviceMatch: preferredDeviceMatch,
        dimensionProfile: effectiveDimensionProfile
      };
    }

    function findBareDeviceFitException(product, device, dimensions, caseChoice) {
      if (caseChoice !== 'no-case' || !dimensions || dimensions.source !== 'device') {
        return null;
      }
      return (product.bareDeviceFitExceptions || []).find(function (exception) {
        return exception.deviceSlug === device.slug && ['length', 'width', 'thickness'].every(function (field) {
          return Number(dimensions[field]) === Number(exception.dimensions[field]);
        });
      }) || null;
    }

    function findBareDeviceFitConfirmation(product, device, dimensions, caseChoice) {
      if (caseChoice !== 'no-case' || !dimensions || dimensions.source !== 'device') {
        return null;
      }
      return (product.bareDeviceFitConfirmations || []).find(function (confirmation) {
        return confirmation.deviceSlug === device.slug;
      }) || null;
    }

    function strictDimensionsFit(product, dimensions) {
      return (product.strictDimensionFields || []).every(function (field) {
        var suffix = field.charAt(0).toUpperCase() + field.slice(1);
        return dimensions && fitsExactRange(dimensions[field], product['min' + suffix], product['max' + suffix]);
      });
    }

    function fitsExactRange(value, min, max) {
      var epsilon = Number.EPSILON * Math.max(1, Math.abs(Number(value)), Math.abs(Number(min)), Math.abs(Number(max))) * 8;
      return fitsRangeWithTolerance(value, min, max, epsilon);
    }

    function findPublishedCompatibility(product, device, caseChoice) {
      var rules = state.evidenceRules && Array.isArray(state.evidenceRules.publishedCompatibility)
        ? state.evidenceRules.publishedCompatibility
        : [];

      return rules.find(function (rule) {
        return rule.familyKey === product.familyKey &&
          rule.deviceSlug === device.slug &&
          ruleScopeMatches(rule.scope, caseChoice);
      }) || null;
    }

    function matchesPublishedNonFit(product, device, caseChoice) {
      var rules = state.evidenceRules && Array.isArray(state.evidenceRules.publishedNonFits)
        ? state.evidenceRules.publishedNonFits
        : [];

      return rules.some(function (rule) {
        return rule.familyKey === product.familyKey &&
          rule.deviceSlug === device.slug &&
          ruleScopeMatches(rule.scope, caseChoice);
      });
    }

    function findConfirmedFitAnchor(product, device, dimensions, caseChoice) {
      var anchors = state.evidenceRules && Array.isArray(state.evidenceRules.confirmedFitAnchors)
        ? state.evidenceRules.confirmedFitAnchors
        : [];

      return anchors.find(function (anchor) {
        return evidenceAnchorMatches(anchor, product, device, dimensions, caseChoice);
      }) || null;
    }

    function matchesConfirmedNonFitAnchor(product, device, dimensions, caseChoice) {
      var anchors = state.evidenceRules && Array.isArray(state.evidenceRules.confirmedNonFitAnchors)
        ? state.evidenceRules.confirmedNonFitAnchors
        : [];

      return anchors.some(function (anchor) {
        return evidenceAnchorMatches(anchor, product, device, dimensions, caseChoice);
      });
    }

    function evidenceAnchorMatches(anchor, product, device, dimensions, caseChoice) {
      if (!anchor || anchor.confidence !== 'A') {
        return false;
      }

      if (anchor.familyKey && anchor.familyKey !== product.familyKey) {
        return false;
      }

      if (anchor.deviceSlug && anchor.deviceSlug !== device.slug) {
        return false;
      }

      if (anchor.requiresMeasuredCase && (!dimensions || dimensions.source !== 'customer')) {
        return false;
      }

      if (!anchor.dimensions) {
        return false;
      }

      var tolerance = Number(anchor.toleranceMm || 0);
      return withinEvidenceTolerance(dimensions.length, anchor.dimensions.length, tolerance) &&
        withinEvidenceTolerance(dimensions.width, anchor.dimensions.width, tolerance) &&
        withinEvidenceTolerance(dimensions.thickness, anchor.dimensions.thickness, tolerance);
    }

    function withinEvidenceTolerance(actual, expected, tolerance) {
      if (actual === null || actual === undefined || expected === null || expected === undefined) {
        return false;
      }

      return Math.abs(Number(actual) - Number(expected)) <= tolerance;
    }

    function noMatch(product) {
      return {
        product: product,
        score: 0,
        tier: 99,
        reasons: [],
        warnings: [],
        ruleFallback: false,
        evidenceConfidence: null,
        publishedCompatibility: false,
        confirmedFit: false,
        exactDeviceMatch: false,
        preferredDeviceMatch: false,
        dimensionProfile: product
      };
    }

    function getApplicableDeviceFamilyRules(product, device, caseChoice) {
      var rules = state.evidenceRules && Array.isArray(state.evidenceRules.deviceFamilyRules)
        ? state.evidenceRules.deviceFamilyRules
        : [];

      return rules.filter(function (rule) {
        return rule.deviceSlug === device.slug &&
          rule.familyKey === product.familyKey &&
          ruleScopeMatches(rule.scope, caseChoice);
      });
    }

    function ruleScopeMatches(scope, caseChoice) {
      if (!scope || scope === 'any') {
        return true;
      }

      if (scope === 'case') {
        return caseChoice === 'case' || caseChoice === 'not-sure';
      }

      return scope === caseChoice;
    }

    function getPeerFamilyAdjustment(product, device, caseChoice, activeRules) {
      if (activeRules.length) {
        return { scoreDelta: 0, confidence: null };
      }

      var groups = state.evidenceRules && Array.isArray(state.evidenceRules.familyPeerGroups)
        ? state.evidenceRules.familyPeerGroups
        : [];
      var allRules = state.evidenceRules && Array.isArray(state.evidenceRules.deviceFamilyRules)
        ? state.evidenceRules.deviceFamilyRules
        : [];
      var group = groups.find(function (item) {
        return Array.isArray(item.families) && item.families.indexOf(product.familyKey) > -1;
      });

      if (!group) {
        return { scoreDelta: 0, confidence: null };
      }

      var peerFamilies = group.families.filter(function (familyKey) {
        return familyKey !== product.familyKey;
      });

      var peerRules = allRules.filter(function (rule) {
        return rule.deviceSlug === device.slug &&
          peerFamilies.indexOf(rule.familyKey) > -1 &&
          ruleScopeMatches(rule.scope, caseChoice) &&
          rule.action === 'boost' &&
          Number(rule.scoreDelta || 0) > 0;
      });

      if (!peerRules.length) {
        return { scoreDelta: 0, confidence: null };
      }

      var strongest = peerRules.sort(function (a, b) {
        return Number(b.scoreDelta || 0) - Number(a.scoreDelta || 0);
      })[0];
      var transferRate = Number(group.positiveEvidenceTransfer || 0);
      var maximum = Number(group.maximumTransferredScore || 0);
      var transferred = Math.round(Number(strongest.scoreDelta || 0) * transferRate);

      if (maximum > 0) {
        transferred = Math.min(transferred, maximum);
      }

      return {
        scoreDelta: transferred,
        confidence: strongest.confidence || null
      };
    }

    function getFitWarnings(product, device, caseChoice, activeRules, dimensionProfile) {
      var warnings = [];

      activeRules.forEach(function (rule) {
        if (rule.warning) {
          warnings.push(rule.warning);
        }
      });

      var familyWarnings = state.evidenceRules && Array.isArray(state.evidenceRules.familyWarnings)
        ? state.evidenceRules.familyWarnings
        : [];

      familyWarnings.forEach(function (warning) {
        if (warning.familyKey === product.familyKey &&
            (!warning.deviceSlug || warning.deviceSlug === device.slug) &&
            ruleScopeMatches(warning.scope, caseChoice)) {
          warnings.push(warning.text);
        }
      });

      var productWarnings = state.evidenceRules && Array.isArray(state.evidenceRules.productWarnings)
        ? state.evidenceRules.productWarnings
        : [];

      productWarnings.forEach(function (warning) {
        if (warning.sku === product.sku &&
            (!warning.deviceSlug || warning.deviceSlug === device.slug) &&
            ruleScopeMatches(warning.scope, caseChoice)) {
          warnings.push(warning.text);
        }
      });

      if (caseChoice === 'no-case' && /^RAM-HOL-AP/i.test(product.sku || '')) {
        warnings.push('Form-fit cradle: do not use with a case or an added glass screen protector.');
      }

      if (dimensionProfile && dimensionProfile.configurationWarning) {
        warnings.push(dimensionProfile.configurationWarning);
      }

      return warnings;
    }

    function strongerConfidence(current, incoming) {
      var order = { A: 4, M: 3, B: 2, C: 1 };
      if (!incoming) {
        return current;
      }
      if (!current || (order[incoming] || 0) > (order[current] || 0)) {
        return incoming;
      }
      return current;
    }

    function compareMatches(a, b) {
      if (a.tier !== b.tier) {
        return a.tier - b.tier;
      }
      if (b.score !== a.score) {
        return b.score - a.score;
      }
      return Number(a.product.priority || 100) - Number(b.product.priority || 100);
    }

    function compareFamilyMatches(a, b) {
      if (a.tier !== b.tier) {
        return a.tier - b.tier;
      }

      if (b.score !== a.score) {
        return b.score - a.score;
      }
      return Number(a.match.product.priority || 100) - Number(b.match.product.priority || 100);
    }

    function getPhoneSizeClassAdjustment(product, dimensions) {
      if (!product || !dimensions || !product.deviceTypes || product.deviceTypes.indexOf('Phone') === -1) {
        return 0;
      }

      var length = Number(dimensions.length);
      if (!Number.isFinite(length)) {
        return 0;
      }

      var largePhoneFamilies = ['RAM-HOL-PD4', 'RAM-HOL-UN10'];
      var standardPhoneFamilies = ['RAM-HOL-PD3', 'RAM-HOL-UN7'];
      var preferredFamilies = length >= LARGE_PHONE_CLASS_MIN_LENGTH
        ? largePhoneFamilies
        : standardPhoneFamilies;

      return preferredFamilies.indexOf(product.familyKey) > -1
        ? PHONE_SIZE_CLASS_BONUS
        : 0;
    }

    function getQuickGripProSuitabilityAdjustment(product, dimensions) {
      if (!product || !dimensions || (product.familyKey !== 'RAM-HOL-PD5' && product.familyKey !== 'RAM-HOL-PD7')) {
        return 0;
      }

      var thickness = Number(dimensions.thickness);
      if (!Number.isFinite(thickness)) {
        return 0;
      }

      var preferredFamily = thickness >= THICK_PHONE_THRESHOLD
        ? 'RAM-HOL-PD7'
        : 'RAM-HOL-PD5';

      return product.familyKey === preferredFamily
        ? QUICK_GRIP_PRO_SUITABILITY_BONUS
        : 0;
    }

    function getDimensionProfiles(product) {
      if (!product || !Array.isArray(product.fitConfigurations) || !product.fitConfigurations.length) {
        return product ? [product] : [];
      }

      return product.fitConfigurations.map(function (configuration) {
        return {
          familyKey: product.familyKey,
          holderStyle: product.holderStyle,
          configurationKey: configuration.key || '',
          configurationLabel: configuration.label || configuration.key || '',
          configurationWarning: configuration.warning || '',
          minLength: normaliseRangeValue(configuration.minLength),
          maxLength: normaliseRangeValue(configuration.maxLength),
          minWidth: normaliseRangeValue(configuration.minWidth),
          maxWidth: normaliseRangeValue(configuration.maxWidth),
          minThickness: normaliseRangeValue(configuration.minThickness),
          maxThickness: normaliseRangeValue(configuration.maxThickness)
        };
      });
    }

    function findBestDimensionProfile(product, dimensions, tolerance) {
      var profiles = getDimensionProfiles(product).filter(function (profile) {
        return dimensionProfileHasRules(profile) && dimensionsFitProfile(profile, dimensions, tolerance);
      });

      if (!profiles.length) {
        return null;
      }

      return profiles.sort(function (a, b) {
        var aScore = snugnessScore(a, dimensions) + getTabCradleWidthFitAdjustment(a, dimensions);
        var bScore = snugnessScore(b, dimensions) + getTabCradleWidthFitAdjustment(b, dimensions);
        return bScore - aScore;
      })[0];
    }

    function dimensionProfileHasRules(profile) {
      return profile.minLength !== null ||
        profile.maxLength !== null ||
        profile.minWidth !== null ||
        profile.maxWidth !== null ||
        profile.minThickness !== null ||
        profile.maxThickness !== null;
    }

    function dimensionsFitProfile(profile, dimensions, tolerance) {
      var allowance = Number(tolerance || 0);
      return ['length', 'width', 'thickness'].every(function (field) {
        var suffix = field.charAt(0).toUpperCase() + field.slice(1);
        var min = profile['min' + suffix];
        var max = profile['max' + suffix];
        return (profile.strictDimensionFields || []).indexOf(field) > -1
          ? fitsExactRange(dimensions[field], min, max)
          : fitsRangeWithTolerance(dimensions[field], min, max, allowance);
      });
    }

    function normaliseRangeValue(value) {
      return value === null || value === undefined || value === '' ? null : Number(value);
    }

    function getTabCradleWidthFitAdjustment(product, dimensions) {
      if (!product || !dimensions || (product.holderStyle !== 'Tab-Tite' && product.holderStyle !== 'Tab-Lock')) {
        return 0;
      }

      var deviceWidth = Number(dimensions.width);
      var maximumWidth = Number(product.maxWidth);

      if (!Number.isFinite(deviceWidth) || !Number.isFinite(maximumWidth)) {
        return 0;
      }

      var widthClearance = maximumWidth - deviceWidth;

      if (widthClearance < 0 || widthClearance >= TAB_CRADLE_MAX_USEFUL_WIDTH_CLEARANCE_MM) {
        return 0;
      }

      if (widthClearance <= TAB_CRADLE_IDEAL_WIDTH_CLEARANCE_MM) {
        return Math.round(TAB_CRADLE_WIDTH_FIT_BONUS * (0.78 + (0.22 * widthClearance / TAB_CRADLE_IDEAL_WIDTH_CLEARANCE_MM)));
      }

      return Math.round(
        TAB_CRADLE_WIDTH_FIT_BONUS *
        (TAB_CRADLE_MAX_USEFUL_WIDTH_CLEARANCE_MM - widthClearance) /
        (TAB_CRADLE_MAX_USEFUL_WIDTH_CLEARANCE_MM - TAB_CRADLE_IDEAL_WIDTH_CLEARANCE_MM)
      );
    }

    function snugnessScore(product, dimensions) {
      var components = [];
      addSnugnessComponent(components, dimensions.length, product.minLength, product.maxLength);
      addSnugnessComponent(components, dimensions.width, product.minWidth, product.maxWidth);
      addSnugnessComponent(components, dimensions.thickness, product.minThickness, product.maxThickness);

      if (!components.length) {
        return 0;
      }

      var average = components.reduce(function (sum, value) {
        return sum + value;
      }, 0) / components.length;

      return Math.round(500 * average);
    }

    function addSnugnessComponent(components, value, min, max) {
      if (min === null && max === null) {
        return;
      }

      if (max !== null && max > 0) {
        var slack = Math.max(0, Number(max) - Number(value));
        var scale = Math.max(8, Number(max) * 0.15);
        components.push(1 / (1 + (slack / scale)));
        return;
      }

      if (min !== null) {
        components.push(0.5);
      }
    }


    function prepareAvailabilityOrder(familyMatches) {
      return Promise.all(familyMatches.map(function (item) {
        return resolveFamilyAvailability(item);
      })).then(function (items) {
        return items.sort(function (a, b) {
          if (a.tier !== b.tier) {
            return a.tier - b.tier;
          }

          var scoreGap = Math.abs(a.score - b.score);
          if (scoreGap <= 120 && a.liveAvailable !== b.liveAvailable) {
            if (a.liveAvailable === true) {
              return -1;
            }
            if (b.liveAvailable === true) {
              return 1;
            }
          }

          if (b.score !== a.score) {
            return b.score - a.score;
          }

          return Number(a.match.product.priority || 100) - Number(b.match.product.priority || 100);
        });
      });
    }

    function resolveFamilyAvailability(item) {
      var recommendedProduct = item.match.product;
      item.displayProduct = recommendedProduct;
      item.unavailableRecommendedProduct = null;

      return getLiveProduct(recommendedProduct.handle).then(function (live) {
        item.liveMain = live;
        item.liveAvailable = Boolean(live.available);

        if (live.available) {
          return item;
        }

        return findAvailableFamilyVariant(item).then(function (replacement) {
          if (replacement) {
            item.displayProduct = replacement.product;
            item.liveMain = replacement.live;
            item.liveAvailable = true;
            item.unavailableRecommendedProduct = recommendedProduct;
          }
          return item;
        });
      }).catch(function () {
        item.liveMain = null;
        item.liveAvailable = null;
        return item;
      });
    }

    function findAvailableFamilyVariant(item) {
      var recommendedProduct = item.match.product;
      var candidates = item.family.products.filter(function (product) {
        if (product.sku === recommendedProduct.sku || isCompleteKit(product) || isVibrationOption(product)) {
          return false;
        }
        if (product.suppressUnlessUseCaseSelected && product.specialUseCase !== 'Security / theft deterrence') {
          return false;
        }
        return scoreProduct(product, state.selectedDevice, state.dimensions, state.caseChoice).score > 0;
      }).sort(function (a, b) {
        var aPriority = getAvailabilityVariantPriority(recommendedProduct, a);
        var bPriority = getAvailabilityVariantPriority(recommendedProduct, b);
        if (aPriority !== bPriority) {
          return aPriority - bPriority;
        }
        return Number(a.familyDisplayOrder || 99) - Number(b.familyDisplayOrder || 99);
      });

      return Promise.all(candidates.map(function (product) {
        return getLiveProduct(product.handle).then(function (live) {
          return { product: product, live: live };
        }).catch(function () {
          return null;
        });
      })).then(function (resolved) {
        return resolved.find(function (candidate) {
          return candidate && candidate.live && candidate.live.available;
        }) || null;
      });
    }

    function getAvailabilityVariantPriority(recommendedProduct, candidate) {
      var recommendedRole = recommendedProduct.variantRole || '';
      var candidateRole = candidate.variantRole || '';

      if ((recommendedRole === 'Holder with ball' && candidateRole === 'Holder only') ||
          (recommendedRole === 'Holder only' && candidateRole === 'Holder with ball') ||
          (recommendedRole === 'Standard non-locking holder' && candidateRole === 'Locking holder') ||
          (recommendedRole === 'Locking holder' && candidateRole === 'Standard non-locking holder')) {
        return 1;
      }
      return candidate.defaultFamilyVariant === 'Yes' ? 2 : 3;
    }

    function renderFamilyResults(familyMatches, includeVibration, shouldFocus) {
      var device = state.selectedDevice;
      var dimensions = state.dimensions;
      var caseChoice = state.caseChoice;
      var caseLabel = state.manualMeasurements
        ? (caseChoice === 'case'
            ? 'using your entered case measurements'
            : 'using your entered measurements without a case')
        : caseChoice === 'no-case'
          ? 'without a case'
          : state.caseMethod === 'slim'
            ? 'using estimated slim or standard case dimensions'
            : state.caseMethod === 'rugged'
              ? 'using estimated thick or rugged case dimensions'
              : 'with your entered case measurements';
      var displayGroups = splitFamilyMatchesForDisplay(familyMatches, device);
      var additionalCount = displayGroups.additional.length;
      var hiddenAdditionalCount = displayGroups.hiddenCount || 0;
      var showVibrationPrompt = device.type === 'Phone' && !includeVibration;
      var quickGripComparison = renderQuickGripProComparison(familyMatches, device);

      setResultsMode('ready');
      results.innerHTML = [
        '<div class="mm-holder-finder__summary">',
        '<div class="mm-holder-finder__summary-copy">',
        '<span class="mm-holder-finder__summary-kicker">Your matches</span>',
        '<h2 id="mm-finder-results-title" tabindex="-1">Best holders for ' + escapeHtml(getDeviceDisplayName(device)) + '</h2>',
        '<p>Matched ' + escapeHtml(caseLabel) + ' using ' + formatDimensions(dimensions) + '.</p>',
        '</div>',
        '<div class="mm-holder-finder__summary-actions">',
        '<span class="mm-holder-finder__result-count">' + familyMatches.length + ' compatible ' + (familyMatches.length === 1 ? 'holder' : 'holders') + '</span>',
        '<button class="mm-holder-finder__share" type="button" data-mm-copy-result-link>Copy result link</button>',
        '</div>',
        '</div>',
        state.availabilityTimedOut
          ? '<p class="mm-holder-finder__availability-note"><strong>Recommendations are ready.</strong> The live stock check took too long, so please confirm the latest price and availability on each product page.</p>'
          : '',
        device.type === 'Tablet'
          ? '<p class="mm-holder-finder__tablet-result-note">We’ve prioritised the strongest cradle and a relevant X-Grip option where both styles fit.</p>'
          : '',
        '<div class="mm-holder-finder__grid" data-mm-family-grid></div>',
        additionalCount
          ? [
              '<details class="mm-holder-finder__more-options">',
              '<summary>See ' + additionalCount + ' more compatible ' + (additionalCount === 1 ? 'holder' : 'holders') + '<span class="mm-holder-finder__details-count">' + additionalCount + '</span></summary>',
              '<p class="mm-holder-finder__more-options-note">' + (hiddenAdditionalCount
                ? 'These are the next strongest options. The Finder found ' + familyMatches.length + ' compatible holders in total and is showing the five clearest starting points.'
                : 'These also pass the fit checks, but the options above are the clearest starting point.') + '</p>',
              '<div class="mm-holder-finder__grid mm-holder-finder__grid--more" data-mm-more-family-grid></div>',
              '</details>'
            ].join('')
          : '',
        quickGripComparison,
        renderFitConfirmationOptions(),
        renderMountBuilderShell(familyMatches, includeVibration)
      ].join('');

      var primaryGrid = results.querySelector('[data-mm-family-grid]');
      var moreGrid = results.querySelector('[data-mm-more-family-grid]');

      displayGroups.primary.forEach(function (familyMatch, index) {
        appendFamilyCard(primaryGrid, familyMatch, index, includeVibration);

        if (index === 0 && showVibrationPrompt) {
          appendVibrationPrompt(primaryGrid);
        }
      });

      displayGroups.additional.forEach(function (familyMatch, index) {
        appendFamilyCard(moreGrid, familyMatch, displayGroups.primary.length + index, includeVibration);
      });

      if (state.selectedKitFamilyKey) {
        var selectedKitButton = results.querySelector('[data-mm-select-holder-for-kits="' + state.selectedKitFamilyKey + '"]');
        if (selectedKitButton) {
          selectFamilyForKitBuilder(state.selectedKitFamilyKey, null, state.selectedKitCategory, false);
        }
      }

      announceResults(device, familyMatches.length, Boolean(shouldFocus));
    }

    function appendVibrationPrompt(grid) {
      if (!grid) {
        return;
      }

      var prompt = document.createElement('div');
      prompt.className = 'mm-holder-finder__vibration-prompt';
      prompt.innerHTML = [
        '<span class="mm-holder-finder__vibration-icon" aria-hidden="true"><svg viewBox="0 0 28 28"><path d="M8 5 5 8l3 3M20 5l3 3-3 3M8 17l-3 3 3 3M20 17l3 3-3 3M12 4v20M16 4v20"/></svg></span>',
        '<span class="mm-holder-finder__vibration-copy"><strong>Mounting on a motorcycle?</strong><span>Add vibration-damping holders and complete kits to these results.</span></span>',
        '<button class="mm-holder-finder__secondary-action" type="button" data-mm-show-vibration>Show Vibe-Safe options</button>'
      ].join('');
      grid.appendChild(prompt);
    }

    function revealVibrationOptions() {
      var familyMatch = state.familyMatches.find(function (item) {
        return getKitProducts(item.family, true).some(isVibrationOption);
      });

      if (!familyMatch) {
        return;
      }

      var familyKey = familyMatch.family.key;
      var targetButton = results.querySelector('[data-mm-select-holder-for-kits="' + familyKey + '"]');
      selectFamilyForKitBuilder(familyKey, targetButton, 'vibration', false);

      var builder = results.querySelector('[data-mm-mount-builder]');
      var vibeCategory = builder ? builder.querySelector('[data-mm-kit-category="vibration"]') : null;
      var focusTarget = vibeCategory || (builder ? builder.querySelector('.mm-holder-finder__kit-heading h4') : null);

      if (focusTarget) {
        if (!focusTarget.matches('button, a, input, select, summary, [tabindex]')) {
          focusTarget.setAttribute('tabindex', '-1');
        }
        focusRevealedOption(focusTarget);
        state.vibrationRevealPending = false;
      }

      if (status) {
        status.textContent = 'Vibe-Safe holder and complete mounting options are now shown in the shared mount step.';
      }
    }

    function focusRevealedOption(target) {
      window.requestAnimationFrame(function () {
        target.scrollIntoView({ behavior: getScrollBehavior(), block: 'center' });
        try {
          target.focus({ preventScroll: true });
        } catch (error) {
          target.focus();
        }
      });
    }

    function appendFamilyCard(grid, familyMatch, index, includeVibration) {
      if (!grid) {
        return;
      }

      var card = document.createElement('article');
      card.className = 'mm-holder-finder__family-card' + (index === 0 ? ' mm-holder-finder__family-card--best' : '');
      card.setAttribute('data-family-key', familyMatch.family.key);
      card.innerHTML = renderFamilySkeleton(familyMatch, index, includeVibration);
      grid.appendChild(card);

      hydrateFamilyCard(card, familyMatch, includeVibration);
    }

    function splitFamilyMatchesForDisplay(familyMatches, device) {
      if (!familyMatches.length) {
        return { primary: [], additional: [] };
      }

      if (device.type === 'Phone') {
        return {
          primary: familyMatches.slice(0, 2),
          additional: familyMatches.slice(2),
          hiddenCount: 0
        };
      }

      var primary = [];
      var bestXGrip = familyMatches.find(function (familyMatch) {
        return isTabletXGripResult(familyMatch);
      });
      var bestNonXGrip = familyMatches.find(function (familyMatch) {
        return !isTabletXGripResult(familyMatch);
      });

      if (bestNonXGrip) {
        primary.push(bestNonXGrip);
      }

      if (bestXGrip && primary.indexOf(bestXGrip) === -1) {
        primary.push(bestXGrip);
      }

      if (primary.length < 2) {
        var nextBest = familyMatches.find(function (familyMatch) {
          return primary.indexOf(familyMatch) === -1;
        });

        if (nextBest) {
          primary.push(nextBest);
        }
      }

      primary = familyMatches.filter(function (familyMatch) {
        return primary.indexOf(familyMatch) > -1;
      }).slice(0, 2);

      return {
        primary: primary,
        additional: familyMatches.filter(function (familyMatch) {
          return primary.indexOf(familyMatch) === -1;
        }).slice(0, MAX_VISIBLE_TABLET_ALTERNATIVES),
        hiddenCount: Math.max(0, familyMatches.length - primary.length - MAX_VISIBLE_TABLET_ALTERNATIVES)
      };
    }

    function isTabletXGripResult(familyMatch) {
      var product = familyMatch && familyMatch.match ? familyMatch.match.product : null;

      return Boolean(product && product.holderStyle === 'X-Grip' &&
        product.deviceTypes && product.deviceTypes.indexOf('Tablet') > -1);
    }

    function isEvidenceSupportedResult(familyMatch) {
      return familyMatch.tier <= 2 ||
        familyMatch.publishedCompatibility ||
        familyMatch.evidenceConfidence === 'A' ||
        familyMatch.evidenceConfidence === 'B' ||
        familyMatch.evidenceConfidence === 'M';
    }

    function renderQuickGripProComparison(familyMatches, device) {
      if (!device || device.type !== 'Phone') {
        return '';
      }

      var hasPd5 = familyMatches.some(function (familyMatch) {
        return familyMatch.family.key === 'RAM-HOL-PD5';
      });
      var hasPd7 = familyMatches.some(function (familyMatch) {
        return familyMatch.family.key === 'RAM-HOL-PD7';
      });
      var comparison = state.evidenceRules && state.evidenceRules.quickGripProComparison;

      if (!hasPd5 || !hasPd7 || !comparison) {
        return '';
      }

      return [
        '<details class="mm-holder-finder__pro-comparison">',
        '<summary>' + escapeHtml(comparison.headline || 'PD5 or PD7? See the difference') + '</summary>',
        '<div class="mm-holder-finder__pro-comparison-body">',
        '<p><strong>PD7:</strong> ' + escapeHtml(comparison.pd7) + '</p>',
        '<p><strong>PD5:</strong> ' + escapeHtml(comparison.pd5) + '</p>',
        '<p class="mm-holder-finder__pro-guardrail">' + escapeHtml(comparison.guardrail) + '</p>',
        '</div>',
        '</details>'
      ].join('');
    }

    function renderFamilySkeleton(familyMatch, index, includeVibration) {
      var product = familyMatch.match.product;
      var dimensionProfile = familyMatch.dimensionProfile || product;
      var label = getResultLabel(familyMatch, index);
      var fitNotes = unique(familyMatch.warnings || []);
      var limitWarnings = getLimitWarnings(dimensionProfile, state.dimensions);

      return [
        '<div class="mm-holder-finder__family-heading">',
        '<div class="mm-holder-finder__family-topline">',
        '<span class="mm-holder-finder__rank-label">' + escapeHtml(label) + '</span>',
        '<div class="mm-holder-finder__badges">',
        product.holderStyle ? '<span class="mm-holder-finder__badge">' + escapeHtml(product.holderStyle) + '</span>' : '',
        product.magSafeCompatible ? '<span class="mm-holder-finder__badge">MagSafe compatible</span>' : '',
        '</div>',
        '</div>',
        '<h3>' + escapeHtml(getFamilyDisplayName(familyMatch)) + '</h3>',
        '<p class="mm-holder-finder__holder-purpose">' + escapeHtml(getHolderPurpose(familyMatch)) + '</p>',
        fitNotes.length || limitWarnings.length
          ? '<div class="mm-holder-finder__fit-alerts">' + fitNotes.map(function (warning) {
              return '<p class="mm-holder-finder__fit-alert"><strong>Fit note:</strong> ' + escapeHtml(warning) + '</p>';
            }).join('') + limitWarnings.map(function (warning) {
              return '<p class="mm-holder-finder__fit-alert mm-holder-finder__fit-alert--caution"><strong>Double-check:</strong> ' + escapeHtml(warning) + '</p>';
            }).join('') + '</div>'
          : '',
        '</div>',
        '<div class="mm-holder-finder__live-product mm-holder-finder__live-product--loading">Loading current product details...</div>',
        renderFitDetails(familyMatch),
        '<div class="mm-holder-finder__related" data-mm-related></div>',
        getKitProducts(familyMatch.family, includeVibration).length ? '<button class="mm-holder-finder__text-action" type="button" data-mm-select-holder-for-kits="' + escapeHtml(familyMatch.family.key) + '" aria-pressed="false">See complete mounts using this holder</button>' : ''
      ].join('');
    }

    function getResultLabel(familyMatch, index) {
      if (familyMatch.publishedCompatibility) {
        return 'Listed as compatible';
      }

      if (familyMatch.confirmedFit || familyMatch.evidenceConfidence === 'A') {
        return 'Fit confirmed';
      }

      if (familyMatch.exactDeviceMatch) {
        return 'Exact device match';
      }

      if (state.dimensions && state.dimensions.source === 'customer') {
        return index === 0 ? 'Best measured match' : 'Compatible by dimensions';
      }

      if (familyMatch.ruleFallback) {
        return 'Fallback option';
      }

      if (isTabletXGripResult(familyMatch)) {
        return 'Universal X-Grip option';
      }

      if (familyMatch.preferredDeviceMatch || familyMatch.evidenceConfidence === 'B' || familyMatch.evidenceConfidence === 'M') {
        return 'Supported fit';
      }

      return index === 0 ? 'Best dimensional match' : 'Compatible by dimensions';
    }

    function getHolderPurpose(familyMatch) {
      var product = familyMatch.match.product;
      var style = product.holderStyle || '';
      var hasLockingVersion = familyMatch.family.products.some(function (item) {
        return item.variantRole === 'Locking holder';
      });
      var lockingFitNeedsConfirmation = familyMatch.family.products.some(function (item) {
        return item.variantRole === 'Locking holder' && item.fitConfirmationRequired;
      });

      if (style === 'X-Grip') {
        return 'Open-sided universal holder with spring-loaded arms and easy access around the device.';
      }
      if (style === 'Quick-Grip') {
        return 'Spring-loaded top-and-bottom grip designed for quick one-handed insertion and removal.';
      }
      if (style === 'Tab-Lock') {
        return 'Key-locking spring-loaded cradle designed to add theft deterrence.';
      }
      if (style === 'Tab-Tite') {
        return 'Spring-loaded cradle with fitted cup ends for a more tailored tablet fit.' + (lockingFitNeedsConfirmation ? ' The key-locking version needs a separate fit check.' : hasLockingVersion ? ' A key-locking version is also available.' : '');
      }
      if (style === 'EZ-Roll\'r' || style === 'Form-Fit') {
        return 'Low-profile device-specific cradle shaped for a close fit.';
      }
      return 'Universal holder selected from the published fit range and available compatibility evidence.';
    }

    function getFamilyDisplayName(familyMatch) {
      var familyName = familyMatch.family.name || '';
      var productTitle = familyMatch.match.product.title || familyName;

      if (!familyName || /tablet holder family$/i.test(familyName) || /tab-tite \/ tab-lock tablet holder family/i.test(familyName)) {
        return productTitle.replace(/\s*\(RAM-[^)]+\)\s*$/i, '').trim();
      }

      return familyName;
    }

    function renderFitDetails(familyMatch) {
      var product = familyMatch.match.product;
      var dimensions = state.dimensions;
      var dimensionProfile = familyMatch.dimensionProfile || product;
      var rangeRows = getHolderRangeRows(dimensionProfile);
      var setupLabel = state.caseChoice === 'case'
        ? (state.dimensions && state.dimensions.source === 'case-estimate'
            ? 'Your device with ' + getCaseMethodLabel(state.caseMethod) + ' (estimated)'
            : 'Your device with case')
        : 'Your device';

      return [
        '<details class="mm-holder-finder__fit-details">',
        '<summary>Why this fits your device</summary>',
        '<div class="mm-holder-finder__fit-details-body">',
        '<p class="mm-holder-finder__fit-details-intro">The recommendation combines the selected model, the dimensions used for this search, and available fit evidence.</p>',
        '<dl class="mm-holder-finder__fit-measurements">',
        '<div><dt>' + escapeHtml(setupLabel) + '</dt><dd>' + formatDimensions(dimensions) + '</dd></div>',
        dimensionProfile.configurationLabel
          ? '<div><dt>Included cup set used</dt><dd>' + escapeHtml(dimensionProfile.configurationLabel) + '</dd></div>'
          : '',
        rangeRows.map(function (row) {
          return '<div><dt>Holder ' + escapeHtml(row.label.toLowerCase()) + '</dt><dd>' + escapeHtml(row.value) + '</dd></div>';
        }).join(''),
        '</dl>',
        familyMatch.reasons.length
          ? '<div class="mm-holder-finder__match-basis"><strong>How it was matched</strong><ul>' +
              familyMatch.reasons.map(function (reason) {
                return '<li>' + escapeHtml(reason) + '</li>';
              }).join('') +
            '</ul></div>'
          : '',
        '</div>',
        '</details>'
      ].join('');
    }

    function getHolderRangeRows(product) {
      var rows = [];
      addHolderRangeRow(rows, 'Length', product.minLength, product.maxLength);
      addHolderRangeRow(rows, 'Width', product.minWidth, product.maxWidth);
      addHolderRangeRow(rows, 'Thickness', product.minThickness, product.maxThickness);
      return rows;
    }

    function addHolderRangeRow(rows, label, min, max) {
      if (min === null && max === null) {
        return;
      }
      rows.push({ label: label, value: formatRange(min, max) });
    }

    function formatRange(min, max) {
      if (min !== null && max !== null) {
        return formatNumber(min) + '–' + formatNumber(max) + ' mm';
      }
      if (max !== null) {
        return 'Up to ' + formatNumber(max) + ' mm';
      }
      return 'At least ' + formatNumber(min) + ' mm';
    }

    function getLimitWarnings(product, dimensions) {
      if (!dimensions || (dimensions.source !== 'customer' && dimensions.source !== 'case-estimate')) {
        return [];
      }

      var boundaries = [];
      addLimitBoundary(boundaries, 'length', dimensions.length, product.minLength, 'minimum', 2);
      addLimitBoundary(boundaries, 'length', dimensions.length, product.maxLength, 'maximum', 2);
      addLimitBoundary(boundaries, 'width', dimensions.width, product.minWidth, 'minimum', 2);
      addLimitBoundary(boundaries, 'width', dimensions.width, product.maxWidth, 'maximum', 2);
      addLimitBoundary(boundaries, 'thickness', dimensions.thickness, product.minThickness, 'minimum', 1);
      addLimitBoundary(boundaries, 'thickness', dimensions.thickness, product.maxThickness, 'maximum', 1);
      boundaries.sort(function (a, b) { return a.distance - b.distance; });

      if (!boundaries.length) {
        return [];
      }

      var closest = boundaries[0];
      if (dimensions.source === 'case-estimate') {
        return ['This estimated fit is close to the holder’s ' + closest.side + '. Measure your case to confirm.'];
      }
      return ['This is a close fit: your ' + closest.dimension + ' is within ' + formatNumber(closest.distance) + ' mm of the holder’s ' + closest.side + '. Please double-check that measurement.'];
    }

    function addLimitBoundary(boundaries, dimension, value, boundary, side, threshold) {
      if (boundary === null || boundary === undefined) {
        return;
      }
      var distance = Math.abs(Number(value) - Number(boundary));
      if (distance <= threshold) {
        boundaries.push({
          dimension: dimension,
          distance: distance,
          side: side + ' ' + dimension + ' of ' + formatNumber(boundary) + ' mm'
        });
      }
    }

    function hydrateFamilyCard(card, familyMatch, includeVibration) {
      var mainProduct = familyMatch.displayProduct || familyMatch.match.product;
      var related = getRelatedProducts(familyMatch.family, mainProduct, includeVibration);

      if (familyMatch.liveMain) {
        if (!card.isConnected) {
          return;
        }
        card.querySelector('.mm-holder-finder__live-product').outerHTML = renderLiveProduct(mainProduct, familyMatch.liveMain, true, familyMatch);
        hydrateRelatedProducts(card, related);
        return;
      }

      if (state.availabilityTimedOut) {
        if (!card.isConnected) {
          return;
        }
        card.querySelector('.mm-holder-finder__live-product').outerHTML = renderLiveProduct(mainProduct, null, true, familyMatch);
        hydrateRelatedProducts(card, related, true);
        return;
      }

      getLiveProductWithin(mainProduct.handle, AVAILABILITY_TIMEOUT_MS).then(function (live) {
        if (!card.isConnected) {
          return;
        }
        card.querySelector('.mm-holder-finder__live-product').outerHTML = renderLiveProduct(mainProduct, live, true, familyMatch);
        hydrateRelatedProducts(card, related);
      });
    }

    function hydrateRelatedProducts(card, relatedProducts, useStaticDetails) {
      var wrap = card.querySelector('[data-mm-related]');
      var hasVibrationOption = state.showVibration && relatedProducts.some(isVibrationOption);

      if (!wrap || !relatedProducts.length) {
        if (wrap) {
          wrap.innerHTML = '';
        }
        return;
      }

      wrap.innerHTML = [
        '<details class="mm-holder-finder__related-details"' + (hasVibrationOption ? ' open' : '') + '>',
        '<summary>' + (hasVibrationOption ? 'Vibe-Safe and other versions' : 'Other versions') + ' <span class="mm-holder-finder__details-count">' + relatedProducts.slice(0, 4).length + '</span></summary>',
        '<div class="mm-holder-finder__related-list" data-mm-related-list></div>',
        '</details>'
      ].join('');
      var list = wrap.querySelector('[data-mm-related-list]');

      if (hasVibrationOption && state.vibrationRevealPending) {
        var summary = wrap.querySelector('summary');
        if (summary) {
          focusRevealedOption(summary);
          state.vibrationRevealPending = false;
        }
      }

      relatedProducts.slice(0, 4).forEach(function (product) {
        if (useStaticDetails) {
          list.insertAdjacentHTML('beforeend', renderRelatedProduct(product, null, false, familyMatchKeyFromCard(card)));
          return;
        }
        var placeholder = document.createElement('div');
        placeholder.className = 'mm-holder-finder__related-row mm-holder-finder__related-row--loading';
        placeholder.textContent = 'Loading ' + getProductDisplayLabel(product) + '...';
        list.appendChild(placeholder);

        getLiveProductWithin(product.handle, AVAILABILITY_TIMEOUT_MS).then(function (live) {
          if (placeholder.isConnected) {
            placeholder.outerHTML = renderRelatedProduct(product, live, false, familyMatchKeyFromCard(card));
          }
        });
      });
    }

    function familyMatchKeyFromCard(card) {
      return card ? card.getAttribute('data-family-key') || '' : '';
    }

    function getProductDisplayLabel(product) {
      var role = product.variantRole || '';
      var style = product.holderStyle || '';
      var optionLabel = product.optionLabel || '';
      var isTablet = product.deviceTypes && product.deviceTypes.indexOf('Tablet') > -1;

      if (role === 'Standard non-locking holder' || optionLabel === 'Standard holder') {
        return style === 'Tab-Tite' ? 'Non-locking Tab-Tite cradle' : 'Non-locking holder';
      }

      if (role === 'Locking holder' || optionLabel === 'Locking version') {
        return style === 'Tab-Lock' ? 'Key-locking Tab-Lock cradle' : 'Key-locking holder';
      }

      if (role === 'Holder only' || optionLabel === 'Holder only') {
        if (style === 'X-Grip' && isTablet) {
          return 'Universal X-Grip tablet holder';
        }
        if (style === 'Quick-Grip') {
          return 'Quick-Grip holder without ball';
        }
        return style ? style + ' holder without ball' : 'Holder without ball';
      }

      if (role === 'Holder with ball') {
        return /diamond/i.test(optionLabel)
          ? 'Holder with B Size diamond ball'
          : 'Holder with B Size ball';
      }

      return optionLabel || role || product.title || product.sku || 'Holder option';
    }

    function renderLiveProduct(product, live, isMain, familyMatch) {
      var title = live && live.title ? live.title : product.title;
      var url = live && live.url ? live.url : product.url;
      var image = live && live.featured_image ? normalizeImageUrl(live.featured_image) : '';
      var available = live ? Boolean(live.available) : null;
      var price = live ? live.price : null;
      var compareAt = live ? live.compare_at_price : null;
      var availabilityLabel = available === true ? 'In stock' : available === false ? 'Currently unavailable' : 'Check current availability';
      var availabilityClass = available === true ? 'is-available' : available === false ? 'is-unavailable' : '';
      var exactUnavailable = available === false && familyMatch && familyMatch.tier <= 2;
      var familyKey = familyMatch ? familyMatch.family.key : product.familyKey;
      var shortTitle = getProductDisplayLabel(product);
      var substitutionNote = familyMatch && familyMatch.unavailableRecommendedProduct
        ? 'The usual recommended version is currently unavailable, so we’re showing the closest in-stock version from the same holder family. Other versions remain listed below.'
        : '';

      return [
        '<div class="mm-holder-finder__live-product' + (image ? '' : ' mm-holder-finder__live-product--no-image') + '">',
        image ? '<a class="mm-holder-finder__image" href="' + escapeHtml(url) + '" data-mm-product-link data-mm-product-kind="holder" data-mm-family-key="' + escapeHtml(familyKey) + '" data-mm-sku="' + escapeHtml(product.sku) + '"><img src="' + escapeHtml(image) + '" alt="' + escapeHtml(title) + '" loading="lazy"></a>' : '',
        '<div class="mm-holder-finder__product-copy">',
        '<p class="mm-holder-finder__option-label">' + escapeHtml(isMain ? 'Recommended version' : 'Option') + '</p>',
        '<h4 class="mm-holder-finder__result-title"><a href="' + escapeHtml(url) + '" data-mm-product-link data-mm-product-kind="holder" data-mm-family-key="' + escapeHtml(familyKey) + '" data-mm-sku="' + escapeHtml(product.sku) + '">' + escapeHtml(shortTitle) + '</a></h4>',
        '<p class="mm-holder-finder__sku">' + escapeHtml(product.sku) + '</p>',
        '<div class="mm-holder-finder__commercial">',
        price !== null ? '<span class="mm-holder-finder__price">' + formatMoney(price) + '</span>' : '',
        compareAt && price !== null && compareAt > price ? '<span class="mm-holder-finder__compare">' + formatMoney(compareAt) + '</span>' : '',
        '<span class="mm-holder-finder__availability ' + availabilityClass + '">' + escapeHtml(availabilityLabel) + '</span>',
        '</div>',
        substitutionNote ? '<p class="mm-holder-finder__stock-note">' + escapeHtml(substitutionNote) + '</p>' : '',
        exactUnavailable ? '<p class="mm-holder-finder__stock-note">This is still one of the best matches for your device. It is shown even though it is currently unavailable.</p>' : '',
        '</div>',
        '<a class="mm-holder-finder__view" href="' + escapeHtml(url) + '" data-mm-product-link data-mm-product-kind="holder" data-mm-family-key="' + escapeHtml(familyKey) + '" data-mm-sku="' + escapeHtml(product.sku) + '">View product</a>',
        isMain ? renderIncludedParts(product) : '',
        '</div>'
      ].join('');
    }

    function renderIncludedParts(product) {
      var cradleStyles = ['Tab-Tite', 'Tab-Lock', 'EZ-Roll\'r', 'Form-Fit'];
      var holderLabel = cradleStyles.indexOf(product.holderStyle) > -1 ? 'Cradle' : 'Holder';
      var includesBall = product.variantRole === 'Holder with ball' || /with .*ball/i.test(product.optionLabel || '');
      var includedText = includesBall ? holderLabel + ' + B Size ball' : holderLabel + ' only';
      var neededText = includesBall
        ? 'Socket arm + mounting base'
        : 'Compatible ball adapter + matching socket arm + mounting base';

      return [
        '<div class="mm-holder-finder__included" aria-label="What this product includes">',
        '<span class="mm-holder-finder__included-label">What this product includes</span>',
        '<dl class="mm-holder-finder__parts-summary">',
        '<div class="is-included"><dt>Included</dt><dd>' + escapeHtml(includedText) + '</dd></div>',
        '<div><dt>Still needed</dt><dd>' + escapeHtml(neededText) + '</dd></div>',
        '</dl>',
        '</div>'
      ].join('');
    }

    function renderRelatedProduct(product, live, isKit, familyKey) {
      var title = live && live.title ? live.title : product.title;
      var url = live && live.url ? live.url : product.url;
      var image = live && live.featured_image ? normalizeImageUrl(live.featured_image) : '';
      var available = live ? Boolean(live.available) : null;
      var price = live ? live.price : null;
      var status = available === true ? 'In stock' : available === false ? 'Unavailable' : '';
      var vibrationOption = isVibrationOption(product);
      var productKind = isKit ? 'kit' : 'holder';
      var trackingAttributes = ' data-mm-product-link data-mm-product-kind="' + productKind + '" data-mm-family-key="' + escapeHtml(familyKey || product.familyKey) + '" data-mm-sku="' + escapeHtml(product.sku) + '"';

      return [
        '<div class="mm-holder-finder__related-row' + (isKit ? ' mm-holder-finder__related-row--kit' : '') + (vibrationOption ? ' mm-holder-finder__related-row--vibration' : '') + '"' + (vibrationOption ? ' data-mm-vibration-option' : '') + '>',
        image ? '<a class="mm-holder-finder__related-image" href="' + escapeHtml(url) + '" aria-label="View ' + escapeHtml(title) + '"' + trackingAttributes + '><img src="' + escapeHtml(image) + '" alt="" loading="lazy"></a>' : '<span class="mm-holder-finder__related-image" aria-hidden="true"></span>',
        '<div class="mm-holder-finder__related-copy">',
        '<span class="mm-holder-finder__related-label">' + escapeHtml(getProductDisplayLabel(product)) + (product.fitConfirmationRequired ? ' · Needs fit confirmation' : '') + '</span>',
        product.fitConfirmationRequired ? '<p class="mm-holder-finder__fit-alert"><strong>Fit not confirmed:</strong> ' + escapeHtml(product.fitConfirmationRequired) + ' <a href="' + escapeHtml(buildSupportEmailLink(state.selectedDevice)) + '">Ask us to confirm</a></p>' : '',
        '<a href="' + escapeHtml(url) + '"' + trackingAttributes + '>' + escapeHtml(title) + '</a>',
        '<span class="mm-holder-finder__related-meta">' + escapeHtml(product.sku) + (price !== null ? ' · ' + escapeHtml(formatMoney(price)) : '') + (status ? ' · ' + escapeHtml(status) : '') + '</span>',
        isKit && product.kitFitNote ? '<p class="mm-holder-finder__related-meta">' + escapeHtml(product.kitFitNote) + '</p>' : '',
        '</div>',
        '<a class="mm-holder-finder__mini-link" href="' + escapeHtml(url) + '"' + trackingAttributes + '>View ' + (isKit ? 'mount' : 'option') + '</a>',
        '</div>'
      ].join('');
    }

    function renderMountBuilderShell(familyMatches, includeVibration) {
      var eligibleFamilies = familyMatches.filter(function (familyMatch) {
        return getKitProducts(familyMatch.family, includeVibration).length > 0;
      });
      var isTabletSearch = Boolean(state.selectedDevice && state.selectedDevice.type === 'Tablet');

      if (!eligibleFamilies.length) {
        if (!isTabletSearch) {
          return '';
        }

        return [
          '<section class="mm-holder-finder__mount-builder" aria-labelledby="mm-finder-mount-builder-title">',
          '<div class="mm-holder-finder__mount-builder-intro">',
          '<span class="mm-holder-finder__summary-kicker">Complete your setup</span>',
          '<h3 id="mm-finder-mount-builder-title">Build the rest of your mount</h3>',
          '<p>Open your preferred cradle and add it to your cart, then browse our mounting components for a compatible ball adapter, socket arm and mounting base.</p>',
          '<a class="mm-holder-finder__component-link" href="/collections/general-ram-components">Browse RAM mounting components</a>',
          '</div>',
          '</section>'
        ].join('');
      }

      return [
        '<section class="mm-holder-finder__mount-builder" data-mm-mount-builder aria-labelledby="mm-finder-mount-builder-title">',
        '<div class="mm-holder-finder__mount-builder-intro">',
        '<span class="mm-holder-finder__summary-kicker">Optional next step</span>',
        '<h3 id="mm-finder-mount-builder-title">Complete your mount</h3>',
        isTabletSearch
          ? '<p>Ready-to-use complete mounts are available for holders marked above. If your preferred cradle is not marked, open it and add it to your cart, then browse our mounting components for the remaining parts.</p>'
          : '<p>Already have a compatible arm and base? You can stop here. Otherwise, choose a holder above to see compatible ready-to-use mounts.</p>',
        '</div>',
        '<div class="mm-holder-finder__mount-builder-content" data-mm-mount-builder-content>',
        isTabletSearch
          ? '<p class="mm-holder-finder__mount-builder-empty">Use <strong>See complete mounts using this holder</strong> where available, or <a href="/collections/general-ram-components">browse RAM mounting components</a> for a compatible ball adapter, arm and base.</p>'
          : '<p class="mm-holder-finder__mount-builder-empty">Use the <strong>See complete mounts using this holder</strong> button on your preferred result.</p>',
        '</div>',
        '</section>'
      ].join('');
    }

    function selectFamilyForKitBuilder(familyKey, button, requestedCategory, shouldFocus) {
      var familyMatch = state.familyMatches.find(function (item) {
        return item.family.key === familyKey;
      });

      if (!familyMatch) {
        return;
      }

      var builder = results.querySelector('[data-mm-mount-builder]');
      var wrap = builder ? builder.querySelector('[data-mm-mount-builder-content]') : null;
      var kits = getKitProducts(familyMatch.family, state.showVibration);

      if (!wrap || !kits.length) {
        return;
      }

      var familyChanged = Boolean(state.selectedKitFamilyKey && state.selectedKitFamilyKey !== familyKey);
      state.selectedKitFamilyKey = familyKey;
      if (familyChanged && !requestedCategory) {
        state.selectedKitCategory = '';
      }
      results.querySelectorAll('[data-mm-select-holder-for-kits]').forEach(function (item) {
        item.setAttribute('aria-pressed', item.getAttribute('data-mm-select-holder-for-kits') === familyKey ? 'true' : 'false');
      });

      var groups = groupKitProducts(kits);
      var categoryIdBase = sanitizeId('mm-kit-' + familyKey);
      var selectedCategory = requestedCategory || state.selectedKitCategory;
      if (!groups.some(function (group) { return group.category.key === selectedCategory; })) {
        selectedCategory = '';
      }
      state.selectedKitCategory = selectedCategory;

      wrap.innerHTML = [
        '<div class="mm-holder-finder__kit-heading" tabindex="-1"><span class="mm-holder-finder__selected-holder-label">Selected holder</span><h4>Complete mounts using ' + escapeHtml(getFamilyDisplayName(familyMatch)) + '</h4><p><strong>Where will you mount it?</strong> Choose a location to compare compatible ready-to-use kits.</p></div>',
        '<div class="mm-holder-finder__kit-categories" role="group" aria-label="Choose mounting location">' + groups.map(function (group) {
              var panelId = categoryIdBase + '-' + group.category.key;
              var isSelected = group.category.key === selectedCategory;
              return [
                '<button class="mm-holder-finder__kit-category" type="button" data-mm-kit-category="' + escapeHtml(group.category.key) + '" aria-pressed="' + (isSelected ? 'true' : 'false') + '" aria-controls="' + escapeHtml(panelId) + '">',
                renderKitCategoryIcon(group.category.key),
                '<span><strong>' + escapeHtml(group.category.label) + '</strong><small>' + group.products.length + ' ' + (group.products.length === 1 ? 'option' : 'options') + '</small></span></button>'
              ].join('');
            }).join('') + '</div>',
        '<p class="mm-holder-finder__kit-choice-prompt" data-mm-kit-choice-prompt' + (selectedCategory ? ' hidden' : '') + '>Choose a mounting location above to show the compatible kits.</p>',
        '<div data-mm-kit-panels>',
        groups.map(function (group) {
          var panelId = categoryIdBase + '-' + group.category.key;
          return '<section class="mm-holder-finder__kit-panel" id="' + escapeHtml(panelId) + '" data-mm-kit-panel="' + escapeHtml(group.category.key) + '"' + (group.category.key === selectedCategory ? '' : ' hidden') + '>' +
            '<p class="mm-holder-finder__kit-panel-title">' + escapeHtml(group.category.description) + '</p>' +
            (getKitFitNote(group.category.key) ? '<p class="mm-holder-finder__kit-size-note">' + escapeHtml(getKitFitNote(group.category.key)) + '</p>' : '') +
            '<div class="mm-holder-finder__kit-list" data-mm-kit-list="' + escapeHtml(group.category.key) + '"></div></section>';
        }).join(''),
        '</div>'
      ].join('');

      groups.forEach(function (group) {
        var list = wrap.querySelector('[data-mm-kit-list="' + group.category.key + '"]');
        group.products.forEach(function (product) {
          if (state.availabilityTimedOut) {
            list.insertAdjacentHTML('beforeend', renderRelatedProduct(product, null, true, familyKey));
            return;
          }
          var placeholder = document.createElement('div');
          placeholder.className = 'mm-holder-finder__related-row mm-holder-finder__related-row--loading';
          placeholder.textContent = 'Loading mounting option...';
          list.appendChild(placeholder);

          getLiveProductWithin(product.handle, AVAILABILITY_TIMEOUT_MS).then(function (live) {
            if (placeholder.isConnected) {
              placeholder.outerHTML = renderRelatedProduct(product, live, true, familyKey);
            }
          });
        });
      });

      trackFinderEvent('complete_mount_step_opened', {
        device_slug: state.selectedDevice ? state.selectedDevice.slug : '',
        family_key: familyKey,
        mounting_location: selectedCategory
      });

      if (shouldFocus !== false && builder) {
        builder.scrollIntoView({ behavior: getScrollBehavior(), block: 'start' });
        window.setTimeout(function () {
          var heading = wrap.querySelector('.mm-holder-finder__kit-heading');
          if (heading) {
            heading.focus();
          }
        }, 180);
      }
    }

    function groupKitProducts(kits) {
      var grouped = {};
      kits.forEach(function (product) {
        var category = getKitCategory(product);
        if (!grouped[category.key]) {
          grouped[category.key] = { category: category, products: [] };
        }
        grouped[category.key].products.push(product);
      });

      return Object.keys(grouped).map(function (key) {
        return grouped[key];
      }).sort(function (a, b) {
        return a.category.order - b.category.order;
      });
    }

    function getKitCategory(product) {
      var useCase = String(product.specialUseCase || '').toLowerCase();

      if (useCase.indexOf('cup holder') > -1) {
        return { key: 'cup-holder', label: 'Cup holder', description: 'Complete mounts secured inside a suitable vehicle cup holder.', order: 8 };
      }
      if (useCase.indexOf('drill-down') > -1) {
        return { key: 'drill-down', label: 'Drill-down', description: 'Complete mounts with a screw-down base; surface-specific fasteners are separate.', order: 9 };
      }
      if (useCase.indexOf('adhesive') > -1) {
        return { key: 'adhesive', label: 'Adhesive', description: 'Complete mounts using an adhesive base on a compatible surface.', order: 10 };
      }
      if (useCase.indexOf('brake') > -1 || useCase.indexOf('clutch') > -1) {
        return { key: 'brake-clutch', label: 'Brake / clutch', description: 'Motorcycle reservoir combination-base kits; confirm bolt and control clearance.', order: 3.5 };
      }
      if (useCase.indexOf('suction') > -1) {
        return { key: 'windscreen', label: 'Windscreen', description: 'Suction cup mounts for glass and other suitable smooth surfaces.', order: 1 };
      }
      if (useCase.indexOf('fork stem') > -1) {
        return { key: 'fork-stem', label: 'Fork stem', description: 'Motorcycle fork stem mounting kits.', order: 3 };
      }
      if (useCase.indexOf('tough-claw') > -1 || useCase.indexOf('clamp') > -1) {
        return { key: 'clamp', label: 'Clamp / rail', description: 'Tough-Claw clamp mounts for rails, posts and irregular surfaces.', order: 4 };
      }
      if (useCase.indexOf('wheelchair') > -1 || useCase.indexOf('accessibility') > -1) {
        return { key: 'accessibility', label: 'Accessibility', description: 'Mounting kits designed for wheelchair and accessibility setups.', order: 7 };
      }
      if (useCase.indexOf('bicycle') > -1) {
        return { key: 'bicycle', label: 'Bicycle', description: 'Bicycle handlebar kits, including quick-release and low-profile zip-tie options.', order: 5 };
      }
      if (useCase.indexOf('vibration') > -1) {
        return { key: 'vibration', label: 'Vibe-Safe', description: 'Vibration-damping kits for motorcycles and other high-vibration setups.', order: 6 };
      }
      if (useCase.indexOf('handlebar') > -1 || useCase.indexOf('u-bolt') > -1 || useCase.indexOf('strap') > -1) {
        return { key: 'handlebar', label: 'Handlebar', description: 'Handlebar mounting kits using U-bolts, straps or sized clamps.', order: 2 };
      }
      return { key: 'other', label: 'Other locations', description: 'Other complete mounting kits for this holder.', order: 11 };
    }

    function getKitFitNote(categoryKey) {
      if (categoryKey === 'handlebar') {
        return 'Please confirm the U-bolt, strap or clamp size suits your handlebar before ordering.';
      }
      if (categoryKey === 'clamp') {
        return 'Please confirm the clamp size suits the rail, post or mounting point before ordering.';
      }
      return '';
    }

    function renderKitCategoryIcon(key) {
      var paths = {
        windscreen: '<path d="M5 5h18v13H5zM9 22h10M14 18v4"/>',
        handlebar: '<path d="M3 14h22M9 9v10M19 9v10M7 9h4M17 9h4"/>',
        'fork-stem': '<path d="M6 7h16M9 7l3 16M19 7l-3 16M11 18h6"/>',
        clamp: '<path d="M20 7a8 8 0 1 0 0 14M18 7h6v5M18 21h6v-5"/>',
        bicycle: '<circle cx="7" cy="20" r="5"/><circle cx="21" cy="20" r="5"/><path d="m7 20 5-9 4 9H7l4-6h7l3 6M11 8h5"/>',
        accessibility: '<circle cx="13" cy="5" r="2"/><path d="M12 9v8h7l3 6M12 12h6M12 17a6 6 0 1 0 5 3"/>',
        vibration: '<path d="M5 7c2 2 2 4 0 6s-2 4 0 6M11 5c3 3 3 6 0 9s-3 6 0 9M17 7c2 2 2 4 0 6s-2 4 0 6M23 5v18"/>',
        'cup-holder': '<path d="M7 7h14l-2 16H9L7 7zM10 4h8M8 11h12"/>',
        'drill-down': '<path d="M5 18h18v5H5zM14 5v13M10 9h8"/><circle cx="8" cy="20.5" r=".5"/><circle cx="20" cy="20.5" r=".5"/>',
        adhesive: '<path d="M5 20h18M7 17h14l-3-4h-8l-3 4zM14 5v8"/>',
        'brake-clutch': '<path d="M4 12h20M8 8h12v8H8zM20 12l4 7M11 8V5M17 8V5"/>',
        other: '<circle cx="14" cy="14" r="9"/><path d="M14 9v5l3 3"/>'
      };
      return '<svg viewBox="0 0 28 28" aria-hidden="true">' + (paths[key] || paths.other) + '</svg>';
    }

    function selectKitCategory(button) {
      var categories = button.closest('.mm-holder-finder__kit-categories');
      var wrap = button.closest('[data-mm-mount-builder-content]');
      var selectedKey = button.getAttribute('data-mm-kit-category');

      if (!categories || !wrap || !selectedKey) {
        return;
      }

      categories.querySelectorAll('[data-mm-kit-category]').forEach(function (item) {
        item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
      });
      wrap.querySelectorAll('[data-mm-kit-panel]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-mm-kit-panel') !== selectedKey;
      });
      var choicePrompt = wrap.querySelector('[data-mm-kit-choice-prompt]');
      if (choicePrompt) {
        choicePrompt.hidden = true;
      }
      state.selectedKitCategory = selectedKey;
      var selectedGroupLabel = button.querySelector('strong');
      if (status && selectedGroupLabel) {
        status.textContent = selectedGroupLabel.textContent + ' mounting options are now shown.';
      }
      trackFinderEvent('mounting_location_selected', {
        device_slug: state.selectedDevice ? state.selectedDevice.slug : '',
        family_key: state.selectedKitFamilyKey,
        mounting_location: selectedKey
      });
    }

    function renderNoMatches(device) {
      var supportEmail = buildSupportEmailLink(device);
      var editLabel = state.dimensions && state.dimensions.source === 'customer' ? 'Check my measurements' : 'Edit my search';
      setResultsMode('ready');
      results.innerHTML = [
        '<div class="mm-holder-finder__summary mm-holder-finder__summary--no-match">',
        '<div class="mm-holder-finder__summary-copy"><span class="mm-holder-finder__summary-kicker">Let’s double-check</span>',
        '<h2 id="mm-finder-results-title" tabindex="-1">No confident match found for ' + escapeHtml(getDeviceDisplayName(device)) + '</h2>',
        '<p>This does not necessarily mean there is no suitable holder. Double-check the measurements, or send them to us and we’ll confirm the best option.</p>',
        '<div class="mm-holder-finder__no-match-actions">',
        '<button class="mm-holder-finder__secondary-action" type="button" data-mm-check-measurements>' + escapeHtml(editLabel) + '</button>',
        '<a class="mm-holder-finder__view" href="' + escapeHtml(supportEmail) + '" data-mm-product-link data-mm-product-kind="support" data-mm-family-key="" data-mm-sku="">Ask us to confirm by email</a>',
        '<button class="mm-holder-finder__share" type="button" data-mm-copy-result-link>Copy result link</button>',
        '</div></div>',
        '</div>',
        renderFitConfirmationOptions()
      ].join('');
      announceResults(device, 0, true);
    }

    function renderFitConfirmationOptions() {
      return state.products.map(function (product) {
        var confirmation = findBareDeviceFitConfirmation(product, state.selectedDevice, state.dimensions, state.caseChoice);
        if (!confirmation) {
          return '';
        }
        return '<details class="mm-holder-finder__fit-details"><summary>' + escapeHtml(product.sku) + ': fit needs confirmation</summary><div class="mm-holder-finder__fit-details-body"><p>' + escapeHtml(confirmation.text) + '</p><p><a href="' + escapeHtml(buildSupportEmailLink(state.selectedDevice)) + '">Ask us to confirm</a> · <a href="' + escapeHtml(product.url) + '">View holder details</a></p></div></details>';
      }).join('');
    }

    function buildSupportEmailLink(device) {
      var caseLabel = state.caseChoice === 'case'
        ? (state.dimensions && state.dimensions.source === 'customer'
            ? 'With a measured case'
            : 'With a ' + getCaseMethodLabel(state.caseMethod) + ' (estimated)')
        : 'No case';
      var subject = 'Holder Finder fit check for ' + getDeviceDisplayName(device);
      var body = [
        'Hi Modest Mounts,',
        '',
        'Could you please confirm a suitable RAM holder or cradle for this setup?',
        '',
        'Device: ' + getDeviceDisplayName(device),
        'Setup: ' + caseLabel,
        'Measurements: ' + formatDimensions(state.dimensions),
        'Finder result: ' + buildSearchUrl(getCurrentSearchState(true)),
        '',
        'Thanks'
      ].join('\n');

      return 'mailto:' + CONTACT_EMAIL + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
    }

    function renderEmpty() {
      cancelActiveSearch();
      state.hasResults = false;
      root.classList.remove('is-results-view');
      if (panelSummary) {
        panelSummary.hidden = true;
      }
      setResultsMode('empty');
      results.innerHTML = [
        '<div class="mm-holder-finder__empty">',
        '<h2>Your recommendations will appear here</h2>',
        '<p>Choose a phone or tablet, select the model, then tell us whether it has a case.</p>',
        '</div>'
      ].join('');
    }

    function getRelatedProducts(family, mainProduct, includeVibration) {
      return family.products.filter(function (product) {
        if (family.key === 'RAM-HOL-TAB20' && scoreProduct(product, state.selectedDevice, state.dimensions, state.caseChoice).score <= 0) {
          return false;
        }

        if (product.sku === mainProduct.sku || isCompleteKit(product)) {
          return false;
        }

        if (isVibrationOption(product)) {
          return includeVibration;
        }

        if (product.suppressUnlessUseCaseSelected && product.specialUseCase !== 'Security / theft deterrence') {
          return false;
        }

        return true;
      }).sort(function (a, b) {
        return Number(a.familyDisplayOrder || 99) - Number(b.familyDisplayOrder || 99);
      });
    }

    function getKitProducts(family, includeVibration) {
      return family.products.filter(isCompleteKit).filter(function (product) {
        if (product.kitFitVerified && state.selectedDevice && state.dimensions &&
            scoreProduct(product, state.selectedDevice, state.dimensions, state.caseChoice).score <= 0) {
          return false;
        }
        return includeVibration || product.variantRole !== 'Complete kit with Vibe-Safe';
      }).sort(function (a, b) {
        return Number(a.familyDisplayOrder || 99) - Number(b.familyDisplayOrder || 99);
      });
    }

    function isCompleteKit(product) {
      return product.variantRole === 'Complete kit' || product.variantRole === 'Complete kit with Vibe-Safe';
    }

    function isVibrationOption(product) {
      return product.variantRole === 'Vibration damping option' || product.variantRole === 'Complete kit with Vibe-Safe' || product.specialUseCase === 'Motorcycle / vibration';
    }

    function buildFamilies(products) {
      var byKey = {};

      products.forEach(function (product) {
        if (!byKey[product.familyKey]) {
          byKey[product.familyKey] = {
            key: product.familyKey,
            name: product.familyName,
            products: []
          };
        }
        byKey[product.familyKey].products.push(product);
      });

      return Object.keys(byKey).map(function (key) {
        var family = byKey[key];
        family.products.sort(function (a, b) {
          return Number(a.familyDisplayOrder || 99) - Number(b.familyDisplayOrder || 99);
        });
        return family;
      });
    }

    function resetModelSearch() {
      if (modelSearchInput) {
        modelSearchInput.value = '';
      }
      modelPickerDevices = [];
      visibleModelDevices = [];
      activeModelOptionIndex = -1;
      if (modelDataList) {
        modelDataList.innerHTML = '';
      }
      closeModelList();
      if (modelSearchHelp) {
        modelSearchHelp.hidden = true;
      }
      if (modelSearchError) {
        modelSearchError.hidden = true;
      }
      syncModelClearButton();
    }

    function syncModelSearchFromSelection() {
      if (!modelSearchInput) {
        return;
      }
      var selected = state.devices.find(function (device) {
        return device.slug === modelSelect.value;
      });
      modelSearchInput.value = selected ? selected.model : modelSearchInput.value;
      syncModelClearButton();
    }

    function syncModelClearButton() {
      if (modelClearButton) {
        modelClearButton.hidden = !modelSearchInput || !modelSearchInput.value.trim() || modelSearchInput.disabled;
      }
    }

    function syncMeasurementPlaceholders() {
      var placeholders = typeSelect.value === 'Tablet'
        ? ['250', '170', '15']
        : ['163', '78', '14'];
      lengthInput.setAttribute('placeholder', placeholders[0]);
      widthInput.setAttribute('placeholder', placeholders[1]);
      thicknessInput.setAttribute('placeholder', placeholders[2]);
    }

    function getSelectedModelDevice() {
      return modelPickerDevices.find(function (device) {
        return device.slug === modelSelect.value;
      }) || null;
    }

    function renderModelList(query) {
      if (!modelDataList) {
        return;
      }

      var normalizedQuery = normalizeSearchText(query);
      var tokens = normalizedQuery.split(' ').filter(Boolean);
      visibleModelDevices = modelPickerDevices.filter(function (device) {
        if (!tokens.length) {
          return true;
        }
        var haystack = normalizeSearchText(getDeviceSearchTerms(device).join(' '));
        return tokens.every(function (token) {
          return haystack.indexOf(token) > -1;
        });
      });
      activeModelOptionIndex = -1;
      modelSearchInput.removeAttribute('aria-activedescendant');

      if (!visibleModelDevices.length) {
        modelDataList.innerHTML = '<div class="mm-holder-finder__model-empty" role="option" aria-disabled="true">No matching models. Try another spelling or use measurements.</div>';
        return;
      }

      modelDataList.innerHTML = visibleModelDevices.map(function (device, index) {
        var isSelected = device.slug === modelSelect.value;
        return [
          '<div class="mm-holder-finder__model-option' + (isSelected ? ' is-selected' : '') + '"',
          ' id="' + escapeHtml(sanitizeId('mm-model-option-' + device.slug + '-' + index)) + '"',
          ' role="option" aria-selected="' + (isSelected ? 'true' : 'false') + '"',
          ' data-mm-model-option="' + escapeHtml(device.slug) + '">',
          '<span>' + escapeHtml(device.model) + '</span>',
          '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="m5.1 10.2 3.1 3.1 6.7-6.8"/></svg>',
          '</div>'
        ].join('');
      }).join('');
    }

    function openModelList(shouldRender) {
      if (!modelDataList || modelSearchInput.disabled || !modelPickerDevices.length) {
        return;
      }
      window.clearTimeout(modelBlurTimer);
      if (shouldRender !== false) {
        var selectedDevice = getSelectedModelDevice();
        var query = selectedDevice && normalizeSearchText(modelSearchInput.value) === normalizeSearchText(selectedDevice.model)
          ? ''
          : modelSearchInput.value;
        renderModelList(query);
      }
      modelDataList.hidden = false;
      modelSearchInput.setAttribute('aria-expanded', 'true');
      if (modelPicker) {
        modelPicker.classList.add('is-open');
      }
    }

    function closeModelList() {
      if (!modelDataList || !modelSearchInput) {
        return;
      }
      modelDataList.hidden = true;
      modelSearchInput.setAttribute('aria-expanded', 'false');
      modelSearchInput.removeAttribute('aria-activedescendant');
      activeModelOptionIndex = -1;
      if (modelPicker) {
        modelPicker.classList.remove('is-open');
      }
    }

    function moveActiveModelOption(direction) {
      if (!visibleModelDevices.length) {
        return;
      }

      if (activeModelOptionIndex < 0) {
        activeModelOptionIndex = direction > 0 ? 0 : visibleModelDevices.length - 1;
      } else {
        activeModelOptionIndex = (activeModelOptionIndex + direction + visibleModelDevices.length) % visibleModelDevices.length;
      }

      var options = Array.prototype.slice.call(modelDataList.querySelectorAll('[data-mm-model-option]'));
      options.forEach(function (option, index) {
        option.classList.toggle('is-active', index === activeModelOptionIndex);
      });
      var activeOption = options[activeModelOptionIndex];
      if (activeOption) {
        modelSearchInput.setAttribute('aria-activedescendant', activeOption.id);
        activeOption.scrollIntoView({ block: 'nearest' });
      }
    }

    function commitModelChoice(device) {
      if (!device) {
        return;
      }
      window.clearTimeout(modelBlurTimer);
      modelSelect.value = device.slug;
      modelSearchInput.value = device.model;
      syncModelClearButton();
      modelSelect.dispatchEvent(new Event('change', { bubbles: true }));
      closeModelList();
      if (modelSearchError) {
        modelSearchError.hidden = true;
      }
      modelSearchInput.focus();
    }

    function getDeviceSearchTerms(device) {
      return [device.model, device.searchName, device.brand + ' ' + device.model].concat(device.aliases || []).filter(Boolean);
    }

    function normalizeSearchText(value) {
      return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim().replace(/\s+/g, ' ');
    }

    function openFinderEditor(preferredTarget) {
      root.classList.remove('is-results-view');
      panelSummary.hidden = true;

      var focusTarget = preferredTarget || getEditFocusTarget();
      root.querySelector('.mm-holder-finder__panel').scrollIntoView({ behavior: getScrollBehavior(), block: 'start' });

      window.setTimeout(function () {
        if (focusTarget) {
          focusTarget.focus();
        }
      }, 180);
    }

    function cancelActiveSearch() {
      if (state.availabilityTimeoutId) {
        window.clearTimeout(state.availabilityTimeoutId);
        state.availabilityTimeoutId = null;
      }
      state.searchRunId += 1;
    }

    function getSelectedDevice() {
      if (state.manualMeasurements) {
        var type = typeSelect.value;
        var brand = brandSelect.value;

        if (!type) {
          return null;
        }

        return {
          type: type,
          brand: brand || '',
          model: '',
          searchName: '',
          slug: 'manual-measured-' + type.toLowerCase(),
          aliases: [],
          length: null,
          width: null,
          thickness: null,
          displayName: brand
            ? brand + ' ' + type.toLowerCase() + ' using measurements'
            : 'your ' + type.toLowerCase() + ' using measurements'
        };
      }

      return state.devices.find(function (device) {
        return device.slug === modelSelect.value;
      });
    }

    function getDeviceDisplayName(device) {
      return device.displayName || (device.brand + ' ' + device.model).trim();
    }

    function getCaseChoice() {
      var checked = root.querySelector('input[name="mm-finder-case"]:checked');
      return checked ? checked.value : '';
    }

    function getCaseMethod() {
      var checked = root.querySelector('input[name="mm-finder-case-method"]:checked');
      return checked ? checked.value : '';
    }

    function shouldChoosePhoneCaseMethod() {
      var device = getSelectedDevice();
      return Boolean(!state.manualMeasurements && device && device.type === 'Phone' && getCaseChoice() === 'case');
    }

    function measurementsAreRequired() {
      var caseChoice = getCaseChoice();
      var device = getSelectedDevice();

      if (!caseChoice || !device) {
        return false;
      }
      if (state.manualMeasurements) {
        return true;
      }
      if (caseChoice !== 'case') {
        return false;
      }
      return device.type !== 'Phone' || getCaseMethod() === 'measure';
    }

    function getMatchingDimensions(device, caseChoice) {
      if (!state.manualMeasurements && caseChoice === 'no-case') {
        return {
          length: Number(device.length),
          width: Number(device.width),
          thickness: Number(device.thickness),
          source: 'device'
        };
      }

      if (!state.manualMeasurements && device.type === 'Phone' && caseChoice === 'case') {
        var caseMethod = getCaseMethod();
        var allowance = PHONE_CASE_ALLOWANCES[caseMethod];

        if (allowance) {
          return {
            length: Number(device.length) + allowance.length,
            width: Number(device.width) + allowance.width,
            thickness: Number(device.thickness) + allowance.thickness,
            source: 'case-estimate',
            caseMethod: caseMethod
          };
        }
      }

      var enteredLength = Number(lengthInput.value);
      var enteredWidth = Number(widthInput.value);
      var enteredThickness = Number(thicknessInput.value);

      if (!enteredLength || !enteredWidth || !enteredThickness) {
        return null;
      }

      return {
        length: Math.max(enteredLength, enteredWidth),
        width: Math.min(enteredLength, enteredWidth),
        thickness: enteredThickness,
        source: 'customer'
      };
    }

    function measurementsAreComplete() {
      return [lengthInput, widthInput, thicknessInput].every(function (input) {
        var value = Number(input.value);
        return isFinite(value) && value > 0;
      });
    }

    function validateMeasurements(showErrors) {
      var measurementsRequired = measurementsAreRequired();

      if (!measurementsRequired) {
        [lengthInput, widthInput, thicknessInput].forEach(function (input) {
          input.removeAttribute('aria-invalid');
        });
        if (measurementError) {
          measurementError.hidden = true;
        }
        return true;
      }

      var isComplete = measurementsAreComplete();
      var shouldExpose = showErrors || Boolean(measurementError && !measurementError.hidden);
      [lengthInput, widthInput, thicknessInput].forEach(function (input) {
        var isInvalid = !(isFinite(Number(input.value)) && Number(input.value) > 0);
        if (shouldExpose && isInvalid) {
          input.setAttribute('aria-invalid', 'true');
        } else {
          input.removeAttribute('aria-invalid');
        }
      });
      if (measurementError) {
        measurementError.hidden = isComplete || !shouldExpose;
      }
      return isComplete;
    }

    function getMeasurementPlausibilityIssue() {
      if (!measurementsAreComplete()) {
        return null;
      }

      var enteredLength = Math.max(Number(lengthInput.value), Number(widthInput.value));
      var enteredWidth = Math.min(Number(lengthInput.value), Number(widthInput.value));
      var enteredThickness = Number(thicknessInput.value);

      if (enteredLength <= 20 && enteredWidth <= 15 && enteredThickness <= 3) {
        return {
          kind: 'inches',
          blocking: true,
          message: 'These measurements look like inches. The Finder needs millimetres.'
        };
      }

      var type = typeSelect.value;
      var looksUnusual = type === 'Phone'
        ? enteredLength < 80 || enteredLength > 250 || enteredWidth < 35 || enteredWidth > 160 || enteredThickness > 40
        : enteredLength < 120 || enteredLength > 450 || enteredWidth < 60 || enteredWidth > 350 || enteredThickness > 60;

      if (looksUnusual) {
        return {
          kind: 'unusual',
          blocking: false,
          message: 'These measurements look unusual for a ' + (type || 'device').toLowerCase() + '. Please double-check the units and the outside edges.'
        };
      }

      return null;
    }

    function updateMeasurementPlausibility() {
      if (!measurementWarning || !measurementWarningText) {
        return null;
      }

      var issue = getMeasurementPlausibilityIssue();
      measurementWarning.hidden = !issue;
      measurementWarningText.textContent = issue ? issue.message : '';

      if (convertMeasurementsButton) {
        convertMeasurementsButton.hidden = !issue || issue.kind !== 'inches';
      }

      return issue;
    }

    function validateMeasurementPlausibility(showErrors) {
      var issue = updateMeasurementPlausibility();
      if (!issue || !issue.blocking) {
        return true;
      }

      if (showErrors && measurementWarning) {
        measurementWarning.hidden = false;
      }
      return false;
    }

    function clearCaseChoice() {
      root.querySelectorAll('input[name="mm-finder-case"]').forEach(function (input) {
        input.checked = false;
      });
      clearCaseMethodChoice();
    }

    function clearCaseMethodChoice() {
      root.querySelectorAll('input[name="mm-finder-case-method"]').forEach(function (input) {
        input.checked = false;
      });
      state.caseMethod = '';
      if (caseMethodWrap) {
        caseMethodWrap.hidden = true;
      }
      if (caseMethodError) {
        caseMethodError.hidden = true;
      }
    }

    function clearValidation() {
      if (caseError) {
        caseError.hidden = true;
      }
      if (caseMethodError) {
        caseMethodError.hidden = true;
      }
      if (measurementError) {
        measurementError.hidden = true;
      }
      if (measurementWarning) {
        measurementWarning.hidden = true;
      }
      if (convertMeasurementsButton) {
        convertMeasurementsButton.hidden = true;
      }
      [lengthInput, widthInput, thicknessInput].forEach(function (input) {
        input.removeAttribute('aria-invalid');
      });
    }

    function getCurrentSearchState(submitted) {
      return {
        type: typeSelect.value || '',
        brand: brandSelect.value || '',
        model: state.manualMeasurements ? '' : modelSelect.value || '',
        manualMeasurements: Boolean(state.manualMeasurements),
        caseChoice: getCaseChoice(),
        caseMethod: getCaseMethod(),
        length: lengthInput.value || '',
        width: widthInput.value || '',
        thickness: thicknessInput.value || '',
        submitted: Boolean(submitted)
      };
    }

    function saveSearchState(submitted) {
      var saved = getCurrentSearchState(submitted);

      try {
        window.sessionStorage.setItem(FINDER_STORAGE_KEY, JSON.stringify(saved));
      } catch (error) {
        // Search persistence is helpful but must never block the Finder.
      }

      var sharedState = getSearchStateFromUrl();
      if (sharedState && !searchStatesMatch(sharedState, saved)) {
        clearFinderParametersFromAddressBar();
      }
    }

    function getSavedSearchState() {
      var urlState = getSearchStateFromUrl();
      if (urlState) {
        return urlState;
      }

      try {
        var stored = window.sessionStorage.getItem(FINDER_STORAGE_KEY);
        return stored ? JSON.parse(stored) : null;
      } catch (error) {
        return null;
      }
    }

    function restoreSearchState() {
      var saved = getSavedSearchState();
      if (!saved || !saved.type || !state.devices.some(function (device) { return device.type === saved.type; })) {
        return null;
      }

      state.restoringSearch = true;
      typeSelect.value = saved.type;
      syncTypeButtons();
      syncMeasurementPlaceholders();
      resetSelect(brandSelect, 'Select brand');
      populateBrandOptions(saved.type);
      brandSelect.disabled = false;
      brandSelect.value = saved.brand || '';
      resetSelect(modelSelect, 'Select model');
      resetModelSearch();

      if (brandSelect.value) {
        populateModelOptions(saved.type, brandSelect.value);
      }

      state.manualMeasurements = Boolean(saved.manualMeasurements);
      modelSelect.disabled = state.manualMeasurements || !brandSelect.value;
      modelSearchInput.disabled = state.manualMeasurements || !brandSelect.value;

      if (!state.manualMeasurements && saved.model && state.devices.some(function (device) { return device.slug === saved.model; })) {
        modelSelect.value = saved.model;
        syncModelSearchFromSelection();
      }

      var restoredDevice = getSelectedDevice();
      caseWrap.hidden = !restoredDevice;
      if (saved.caseChoice) {
        var caseInput = root.querySelector('input[name="mm-finder-case"][value="' + saved.caseChoice + '"]');
        if (caseInput) {
          caseInput.checked = true;
        }
      }
      if (saved.caseMethod) {
        var caseMethodInput = root.querySelector('input[name="mm-finder-case-method"][value="' + saved.caseMethod + '"]');
        if (caseMethodInput) {
          caseMethodInput.checked = true;
        }
      }

      lengthInput.value = saved.length || '';
      widthInput.value = saved.width || '';
      thicknessInput.value = saved.thickness || '';
      updateManualModeControls();
      updateMeasurementVisibility();
      updateMeasurementPlausibility();
      syncFinderControls();
      updateStepStates();
      state.restoringSearch = false;

      return {
        shouldRun: Boolean(saved.submitted && restoredDevice && getCaseChoice() &&
          (!shouldChoosePhoneCaseMethod() || getCaseMethod()) &&
          (!measurementsAreRequired() || measurementsAreComplete()))
      };
    }

    function buildSearchUrl(saved) {
      var url = new URL(window.location.href);
      clearFinderQueryParameters(url.searchParams);
      url.searchParams.set('hf_type', saved.type);
      if (saved.brand) {
        url.searchParams.set('hf_brand', saved.brand);
      }
      if (saved.model) {
        url.searchParams.set('hf_model', saved.model);
      }
      if (saved.manualMeasurements) {
        url.searchParams.set('hf_manual', '1');
      }
      if (saved.caseChoice) {
        url.searchParams.set('hf_case', saved.caseChoice);
      }
      if (saved.caseMethod) {
        url.searchParams.set('hf_case_method', saved.caseMethod);
      }
      if (saved.length) {
        url.searchParams.set('hf_l', saved.length);
      }
      if (saved.width) {
        url.searchParams.set('hf_w', saved.width);
      }
      if (saved.thickness) {
        url.searchParams.set('hf_t', saved.thickness);
      }
      if (saved.submitted) {
        url.searchParams.set('hf_run', '1');
      }
      return url.toString();
    }

    function searchStatesMatch(first, second) {
      return ['type', 'brand', 'model', 'caseChoice', 'caseMethod', 'length', 'width', 'thickness'].every(function (key) {
        return String(first[key] || '') === String(second[key] || '');
      }) && Boolean(first.manualMeasurements) === Boolean(second.manualMeasurements) &&
        Boolean(first.submitted) === Boolean(second.submitted);
    }

    function copyResultLink(button) {
      var link = buildSearchUrl(getCurrentSearchState(true));
      copyText(link).then(function (copied) {
        if (copied) {
          button.textContent = 'Link copied';
          if (status) {
            status.textContent = 'A shareable link to this Finder result was copied.';
          }
          trackFinderEvent('result_link_copied', getAnalyticsSearchContext());
          window.setTimeout(function () {
            if (button.isConnected) {
              button.textContent = 'Copy result link';
            }
          }, 2200);
          return;
        }
        window.prompt('Copy this result link:', link);
      });
    }

    function copyText(value) {
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        return navigator.clipboard.writeText(value).then(function () {
          return true;
        }).catch(function () {
          return copyTextFallback(value);
        });
      }
      return Promise.resolve(copyTextFallback(value));
    }

    function copyTextFallback(value) {
      var field = document.createElement('textarea');
      field.value = value;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      var copied = false;
      try {
        copied = document.execCommand('copy');
      } catch (error) {
        copied = false;
      }
      document.body.removeChild(field);
      return copied;
    }

    function getSearchStateFromUrl() {
      if (!window.URLSearchParams) {
        return null;
      }
      var params = new URLSearchParams(window.location.search);
      if (!params.get('hf_type')) {
        return null;
      }
      return {
        type: params.get('hf_type') || '',
        brand: params.get('hf_brand') || '',
        model: params.get('hf_model') || '',
        manualMeasurements: params.get('hf_manual') === '1',
        caseChoice: params.get('hf_case') || '',
        caseMethod: params.get('hf_case_method') || '',
        length: params.get('hf_l') || '',
        width: params.get('hf_w') || '',
        thickness: params.get('hf_t') || '',
        submitted: params.get('hf_run') === '1'
      };
    }

    function clearSavedSearchState() {
      try {
        window.sessionStorage.removeItem(FINDER_STORAGE_KEY);
      } catch (error) {
        // Ignore unavailable storage.
      }

      if (window.history && window.history.replaceState && window.URL) {
        clearFinderParametersFromAddressBar();
      }
    }

    function clearFinderParametersFromAddressBar() {
      if (!window.history || !window.history.replaceState || !window.URL) {
        return;
      }
      var url = new URL(window.location.href);
      clearFinderQueryParameters(url.searchParams);
      window.history.replaceState({}, '', url.toString());
    }

    function clearFinderQueryParameters(params) {
      ['hf_type', 'hf_brand', 'hf_model', 'hf_manual', 'hf_case', 'hf_case_method', 'hf_l', 'hf_w', 'hf_t', 'hf_run'].forEach(function (key) {
        params.delete(key);
      });
    }

    function getAnalyticsSearchContext() {
      return {
        device_type: state.selectedDevice ? state.selectedDevice.type : typeSelect.value || '',
        device_slug: state.selectedDevice ? state.selectedDevice.slug : modelSelect.value || '',
        case_choice: state.caseChoice || getCaseChoice(),
        case_method: state.caseMethod || getCaseMethod(),
        measurement_mode: state.dimensions && state.dimensions.source === 'case-estimate'
          ? 'estimated'
          : state.manualMeasurements || measurementsAreRequired() ? 'manual' : 'device'
      };
    }

    function getFinderOrderAttribution() {
      var analyticsContext = getAnalyticsSearchContext();
      var caseLabel = analyticsContext.case_choice === 'no-case'
        ? 'No case'
        : analyticsContext.case_method === 'rugged'
          ? 'Thick or rugged case estimate'
          : analyticsContext.case_method === 'slim'
            ? 'Slim or standard case estimate'
            : analyticsContext.case_choice === 'case'
              ? 'Measured with case'
              : 'Not specified';
      var measurementLabel = analyticsContext.measurement_mode === 'estimated'
        ? 'Estimated case dimensions'
        : analyticsContext.measurement_mode === 'manual'
          ? 'Customer measurements'
          : 'Device dimensions';

      return {
        device: state.selectedDevice ? getDeviceDisplayName(state.selectedDevice) : analyticsContext.device_slug,
        device_slug: analyticsContext.device_slug,
        case_label: caseLabel,
        measurement_label: measurementLabel,
        dimensions: state.dimensions ? formatDimensions(state.dimensions) : '',
        finder_version: FINDER_VERSION
      };
    }

    function saveFinderCartAttribution() {
      if (!window.fetch) {
        return;
      }

      var attribution = getFinderOrderAttribution();
      var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
      var endpoint = rootPath.replace(/\/?$/, '/') + 'cart/update.js';

      window.fetch(endpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            __mm_holder_finder_used: 'Yes',
            __mm_holder_finder_device: attribution.device,
            __mm_holder_finder_case: attribution.case_label,
            __mm_holder_finder_measurement: attribution.measurement_label,
            __mm_holder_finder_dimensions: attribution.dimensions,
            __mm_holder_finder_version: attribution.finder_version
          }
        })
      }).catch(function () {
        // Attribution must never interrupt the Finder experience.
      });
    }

    function saveFinderProductAttribution(productLink, productKind) {
      if (!window.URL) {
        return;
      }

      try {
        var productUrl = new URL(productLink.href, window.location.href);
        var productMatch = productUrl.pathname.match(/\/products\/([^/?#]+)/i);
        if (!productMatch || productUrl.origin !== window.location.origin) {
          return;
        }

        var attribution = getFinderOrderAttribution();
        attribution.saved_at = Date.now();
        attribution.product_handle = decodeURIComponent(productMatch[1]);
        attribution.result_type = productKind === 'kit' ? 'Complete mount' : 'Holder';
        attribution.recommended_sku = productLink.getAttribute('data-mm-sku') || '';
        attribution.family_key = productLink.getAttribute('data-mm-family-key') || '';
        window.localStorage.setItem(FINDER_ATTRIBUTION_KEY, JSON.stringify(attribution));
      } catch (error) {
        // Storage restrictions must never interrupt product navigation.
      }
    }

    function trackFinderEvent(eventName, details) {
      var payload = {
        event: 'mm_holder_finder_' + eventName,
        holder_finder_event: eventName,
        holder_finder_version: FINDER_VERSION
      };
      Object.keys(details || {}).forEach(function (key) {
        payload[key] = details[key];
      });

      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(payload);
      }

      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === 'function'
      ) {
        try {
          window.Shopify.analytics.publish('modest_mounts:holder_finder', payload);
        } catch (error) {
          // Keep the Finder working if Customer Events is unavailable.
        }
      }

      try {
        root.dispatchEvent(new CustomEvent('mm:holder-finder', {
          bubbles: true,
          detail: payload
        }));
      } catch (error) {
        // Older browsers can use the dataLayer event when available.
      }
    }

    function updateQuerySummary(device, dimensions, caseChoice) {
      if (!summaryDevice || !summaryMeta) {
        return;
      }
      summaryDevice.textContent = getDeviceDisplayName(device);
      summaryMeta.textContent = (caseChoice === 'case'
        ? (dimensions.source === 'case-estimate'
            ? (state.caseMethod === 'rugged' ? 'Thick or rugged case estimate' : 'Slim or standard case estimate')
            : 'With measured case')
        : 'No case') + ' · ' + formatDimensions(dimensions);
    }

    function getCaseMethodLabel(caseMethod) {
      return caseMethod === 'rugged' ? 'thick or rugged case' : 'slim or standard case';
    }

    function formatDimensions(dimensions) {
      if (!dimensions) {
        return '';
      }
      return formatNumber(dimensions.length) + ' × ' + formatNumber(dimensions.width) + ' × ' + formatNumber(dimensions.thickness) + ' mm';
    }

    function setResultsMode(mode) {
      results.classList.remove('is-empty', 'is-loading', 'is-ready', 'is-error');
      results.classList.add('is-' + mode);
      results.setAttribute('aria-busy', mode === 'loading' ? 'true' : 'false');
    }

    function announceResults(device, count, shouldFocus) {
      if (status) {
        status.textContent = count
          ? count + ' compatible ' + (count === 1 ? 'holder was' : 'holders were') + ' found for ' + getDeviceDisplayName(device) + '.'
          : 'No confident holder match was found for ' + getDeviceDisplayName(device) + '.';
      }
      if (!shouldFocus) {
        return;
      }

      window.requestAnimationFrame(function () {
        var heading = results.querySelector('#mm-finder-results-title');
        results.scrollIntoView({ behavior: getScrollBehavior(), block: 'start' });
        if (heading) {
          try {
            heading.focus({ preventScroll: true });
          } catch (error) {
            heading.focus();
          }
        }
      });
    }

    function getScrollBehavior() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }

    function getEditFocusTarget() {
      if (!typeSelect.value) {
        return typeButtons.find(function (button) { return !button.disabled; }) || null;
      }
      if (!state.manualMeasurements && modelSelect.value) {
        return modelSearchInput;
      }
      if (state.manualMeasurements && getCaseChoice()) {
        return lengthInput;
      }
      return brandSelect.disabled ? manualMeasurementsButton : brandSelect;
    }

    function focusCurrentStep() {
      var target = getEditFocusTarget();
      if (target) {
        target.focus();
      }
    }

    function sanitizeId(value) {
      return String(value || '').toLowerCase().replace(/[^a-z0-9_-]+/g, '-').replace(/^-+|-+$/g, '');
    }

    function holderHasDimensionRules(product) {
      return getDimensionProfiles(product).some(dimensionProfileHasRules);
    }

    function dimensionsFit(product, dimensions) {
      return Boolean(findBestDimensionProfile(product, dimensions, 0));
    }

    function dimensionsFitWithTolerance(product, dimensions, tolerance) {
      return Boolean(findBestDimensionProfile(product, dimensions, tolerance));
    }

    function fitsRangeWithTolerance(value, min, max, tolerance) {
      var allowance = Number(tolerance || 0);
      var adjustedMin = min === null ? null : Number(min) - allowance;
      var adjustedMax = max === null ? null : Number(max) + allowance;
      return fitsRange(value, adjustedMin, adjustedMax);
    }

    function fitsRange(value, min, max) {
      if (min !== null && Number(value) < Number(min)) {
        return false;
      }
      if (max !== null && Number(value) > Number(max)) {
        return false;
      }
      return true;
    }

    function getLiveProduct(handle) {
      if (!handle) {
        return Promise.reject(new Error('Missing product handle'));
      }

      if (LIVE_PRODUCT_CACHE[handle]) {
        return LIVE_PRODUCT_CACHE[handle];
      }

      var rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      LIVE_PRODUCT_CACHE[handle] = fetch(rootUrl + 'products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Product request failed');
        }
        return response.json();
      });

      return LIVE_PRODUCT_CACHE[handle];
    }

    function getLiveProductWithin(handle, timeoutMs) {
      return new Promise(function (resolve) {
        var settled = false;
        var timer = window.setTimeout(function () {
          if (!settled) {
            settled = true;
            resolve(null);
          }
        }, timeoutMs);

        getLiveProduct(handle).then(function (live) {
          if (!settled) {
            settled = true;
            window.clearTimeout(timer);
            resolve(live);
          }
        }).catch(function () {
          if (!settled) {
            settled = true;
            window.clearTimeout(timer);
            resolve(null);
          }
        });
      });
    }

    function fetchJson(url) {
      if (!url) {
        return Promise.reject(new Error('Missing finder data URL'));
      }
      return fetch(url, { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) {
          throw new Error('Finder data request failed');
        }
        return response.json();
      });
    }

    function formatMoney(cents) {
      var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active ? window.Shopify.currency.active : 'AUD';
      try {
        return new Intl.NumberFormat('en-AU', {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: 2
        }).format(Number(cents) / 100);
      } catch (error) {
        return '$' + (Number(cents) / 100).toFixed(2);
      }
    }

    function normalizeImageUrl(url) {
      if (!url) {
        return '';
      }
      if (url.indexOf('//') === 0) {
        return 'https:' + url;
      }
      return url;
    }

    function clearMeasurements() {
      lengthInput.value = '';
      widthInput.value = '';
      thicknessInput.value = '';
      updateMeasurementPlausibility();
    }

    function resetSelect(select, label) {
      select.innerHTML = '';
      addOption(select, '', label);
    }

    function addOption(select, value, label) {
      var option = document.createElement('option');
      option.value = value;
      option.textContent = label;
      select.appendChild(option);
    }

    function unique(values) {
      return values.filter(function (value, index, array) {
        return value && array.indexOf(value) === index;
      });
    }

    function formatNumber(value) {
      var number = Number(value);
      if (!isFinite(number)) {
        return '';
      }
      return String(Math.round(number * 1000) / 1000);
    }

    function escapeHtml(value) {
      return String(value === null || value === undefined ? '' : value).replace(/[&<>"']/g, function (character) {
        return {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#039;'
        }[character];
      });
    }
  });
})();
